{
  "absent": "Absent",
  "absent_student": "Absent Student",
  "academic_fees_detail": "Academic Fees Detail",
  "academics": "Academics",
  "assign_subject_teacher": "Assign Subject Teacher",
  "accountant": "Accountant",
  "accountant_list": "Accountant List",
  "accountant_photo": "Accountant Photo",
  "accountants": "Accountants",
  "action": "Action",
  "active": "Active",
  "add": "Add",
  "add_accountant": "Add Accountant",
  "add_admin_user": "Add Admin User",
  "add_another_language": "Add Another Language",
  "add_book": "Add Book",
  "add_category": "Add Category",
  "add_class": "Add Class",
  "add_exam": "Add Exam",
  "add_expense": "Add Expense",
  "add_expense_head": "Add Expense Head",
  "add_fee_category": "Add Fee Category",
  "add_fees": "Add Fees",
  "add_fees_discount": "Add Fees Discount",
  "add_fees_group": "Add Fees Group",
  "add_fees_master": "Add Fees Master",
  "add_fees_type": "Add Fees Type",
  "add_grade": "Add Grade",
  "add_hostel": "Add Hostel",
  "add_hostel_room": "Add Hostel Room",
  "add_image": "Add Image",
  "add_income": "Add Income",
  "add_item": "Add Item",
  "add_item_category": "Add Item Category",
  "add_item_stock": "Add Item Stock",
  "add_item_store": "Add Item Store",
  "add_item_supplier": "Add Item Supplier",
  "add_language": "Add Language",
  "add_librarian": "Add Librarian",
  "add_member": "Add Member",
  "add_more_details": "Add More Details",
  "add_new_sms_configuration": "Add New SMS Configuration",
  "add_room_type": "Add Room Type",
  "add_section": "Add Section",
  "add_session": "Add Session",
  "add_student": "Add Student",
  "add_subject": "Add Subject",
  "add_teacher": "Add Teacher",
  "add_timetable": "Add Timetable",
  "add_vehicle": "Add Vehicle",
  "Add/Edit": "Add/Edit",
  "address": "Address",
  "address_details": "Address Details",
  "admin": "Admin",
  "admin_email": "Admin Email",
  "admin_login": "Admin Login",
  "admin_name": "Admin Name",
  "admin_password": "Admin Password",
  "admin_users": "Admin Users",
  "admission": "Admission",
  "admission_date": "Admission Date",
  "admission_discount": "Admission Discount",
  "admission_no": "Admission No",
  "all": "All",
  "all_users": "All Users",
  "amount": "Amount",
  "applied": "Applied",
  "apply_discount": "Apply Discount",
  "assign / view": "Assign / View Student",
  "assign_fees_discount": "Assign Fees Discount",
  "assign_fees_group": "Assign Fees Group",
  "assign_subject": "Assign Subject",
  "assign_subjects": "Assign Subjects",
  "assign_vehicle": "Assign Vehicle",
  "assign_vehicle_on_route": "Assign Vehicle On Route",
  "assigned": "Assigned",
  "assignment_list": "Assignment List",
  "assignments": "Assignments",
  "attach_document": "Attach Document",
  "attendance": "Attendance",
  "attendance_already_submitted_as_holiday": "Attendance Already Submitted As Holiday",
  "attendance_already_submitted_you_can_edit_record": "Attendance Already Submitted You Can Edit Record",
  "attendance_by_date": "Attendance By Date",
  "attendance_report": "Attendance Report",
  "attendance_saved_successfully": "Attendance Saved Successfully",
  "auth_Key": "Auth Key",
  "authentication_token": "Authentication Token",
  "author": "Author",
  "available_for": "Available For",
  "available_for_all_classes": "Available For All Classes",
  "available_quantity": "Available Quantity",
  "backup / restore": "Backup / Restore",
  "backup_files": "Backup Files",
  "backup_history": "Backup History",
  "balance": "Balance",
  "balance_description": "Balance Description",
  "balance_details": "Balance Details",
  "balance_fees": "Balance Fees",
  "balance_fees_report": "Balance Fees Report",
  "bank_account_no": "Bank Account Number",
  "bank_name": "Bank Name",
  "basic_information": "Basic Information",
  "book": "Book",
  "book_details": "Book Details",
  "book_issued": "Book Issued",
  "book_list": "Book List",
  "book_no": "Book No",
  "book_title": "Book Title",
  "bookprice": "Book Price",
  "books": "Books",
  "books_issue_return": "Books Issue Return",
  "by_date": "By Date",
  "cancel": "Cancel",
  "cash": "Cash",
  "cast": "Caste",
  "category": "Category",
  "category_list": "Category List",
  "change_password": "Change Password",
  "change_status": "Change Status",
  "change_username": "Change Username",
  "cheque": "Cheque",
  "class": "Class",
  "class_fees_detail": "Class Fees Detail",
  "class_list": "Class List",
  "class_section": "Class Section",
  "class_timetable": "Class Timetable",
  "classes": "Classes",
  "click_to_return": "Click To Return",
  "clickatell_api_id": "Clickatell Api Id",
  "clickatell_password": "Clickatell Password",
  "clickatell_sms_gateway": "Clickatell SMS Gateway",
  "clickatell_username": "Clickatell Username",
  "collect_fees": "Collect Fees",
  "collect_transport_fees": "Collect Transport Fees",
  "collection": "Collection",
  "communicate": "Communicate",
  "compose_new_message": "Compose New Message",
  "confirm_password": "Confirm Password",
  "confirm_return": "Confirm Return",
  "confirm_username": "Confirm Username",
  "confirmation": "Confirmation",
  "contact_person": "Contact Person",
  "contact_person_email": "Contact Person Email",
  "contact_person_name": "Contact Person Name",
  "contact_person_phone": "Contact Person Phone",
  "content_file": "Content File",
  "content_list": "Content List",
  "content_title": "Content Title",
  "content_type": "Content Type",
  "continue": "Continue",
  "cost_per_bed": "Cost Per Bed",
  "create_backup": "Create Backup",
  "create_category": "Create Category",
  "create_route": "Create Route",
  "created_at": "Created At",
  "currency": "Currency",
  "currency_symbol": "Currency Symbol",
  "current": "Current",
  "current_address": "Current Address",
  "current_password": "Current Password",
  "current_session": "Current Session",
  "current_theme": "Current Theme",
  "current_username": "Current Username",
  "custom_sms_gateway": "Custom SMS Gateway",
  "date": "Date",
  "date_format": "Date Format",
  "date_from": "Date From",
  "date_of_birth": "Date of Birth",
  "date_to": "Date To",
  "day": "day",
  "dd": "DD",
  "delete": "Delete",
  "deposit": "Deposit",
  "description": "Description",
  "detailed_view": "Detailed View",
  "details": "Details",
  "disabled": "Disabled",
  "discount": "Discount",
  "discount_code": "Discount Code",
  "discount_of": "Discount of",
  "dl_sample_import": "Download Sample Import File",
  "document_list": "Document List",
  "documents": "Documents",
  "download": "Download",
  "download_to_read": "Download to read it here",
  "dismiss": "Dismiss",
  "zoom": "Zoom",
  "zoom_in": "Zoom in",
  "zoom_out": "Zoom out",
  "reset_zoom": "Fit to width",
  "file_replaced_notice": "A file you had saved has been replaced with a newer version. Download it again to read the new one.",
  "replace_file": "Replace file",
  "replace_file_warning": "The current file will be deleted. Students who already downloaded it will see the old copy removed from their device, and will need to download the new one.",
  "leave_empty_to_keep_file": "Leave empty to keep the current file.",
  "will_replace": "Will replace the current file with",
  "title_required": "Title is required",
  "download_first_to_read": "Download it first, then you can read it here",
  "saved_offline": "Saved",
  "saved_on_device": "Saved on this device",
  "saved_tap_to_download_again": "Saved on this device — tap to download again",
  "saving": "Saving",
  "opening_saved_copy": "Opening your saved copy…",
  "offline_copy": "Offline copy",
  "download_center": "Download Center",
  "download_pdf": "Download PDF",
  "driver_contact": "Driver Contact",
  "driver_license": "Driver License",
  "driver_name": "Driver Name",
  "due_date": "Due Date",
  "edit": "Edit",
  "edit_accountant": "Edit Accountant",
  "edit_book": "Edit Book",
  "edit_category": "Edit Category",
  "edit_class": "Edit Class",
  "edit_exam": "Edit Exam",
  "edit_expense": "Edit Expense",
  "edit_expense_head": "Edit Expense Head",
  "edit_fee_category": "Edit Fee Category",
  "edit_fees_discount": "Edit Fees Discount",
  "edit_fees_group": "Edit Fees Group",
  "edit_fees_master": "Edit Fees Master",
  "edit_fees_type": "Edit Fees Type",
  "edit_grade": "Edit Grade",
  "edit_hostel": "Edit Hostel",
  "edit_hostel_room": "Edit Hostel Room",
  "edit_income": "Edit Income",
  "edit_income_head": "Edit Income Head",
  "edit_item": "Edit Item",
  "edit_item_category": "Edit Item Category",
  "edit_item_store": "Edit Item Store",
  "edit_item_supplier": "Edit Item Supplier",
  "edit_librarian": "Edit Librarian",
  "edit_logo": "Edit Logo",
  "edit_message": "Edit Message",
  "edit_notification": "Edit Notification",
  "edit_room_type": "Edit Room Type",
  "edit_route": "Edit Route",
  "edit_section": "Edit Section",
  "edit_session": "Edit Session",
  "edit_setting": "Edit Setting",
  "edit_subject": "Edit Subject",
  "edit_teacher": "Edit Teacher",
  "edit_vehicle": "Edit Vehicle",
  "edit_vehicle_on_route": "Edit Vehicle On Route",
  "email": "Email",
  "email_/_sms": "Email / SMS",
  "email_/_sms_log": "Email / SMS Log",
  "email_engine": "Email Engine",
  "email_setting": "Email Setting",
  "enabled": "Enabled",
  "end_time": "End Time",
  "enrollment_no": "Enrollment Number",
  "enter_room_no": "Enter Room Number",
  "exam": "Exam",
  "exam_list": "Exam List",
  "exam_marks_report": "Exam Marks Report",
  "exam_name": "Exam Name",
  "exam_not_allotted": "Exam Not Allotted",
  "exam_result": "Exam Result",
  "exam_schedule": "Exam Schedule",
  "exam_scheduled": "Exam Scheduled",
  "exam_status": "Exam Status",
  "exam_timetable": "Exam Timetable",
  "examinations": "Board Exams",
  "expense_detail": "Expense Detail",
  "expense_details": "Expense Details",
  "expense_head": "Expense Head",
  "expense_head_list": "Expense Head List",
  "expense_id": "Expense Id",
  "expense_list": "Expense List",
  "expense_result": "Expense Result",
  "expenses": "Expenses",
  "export_format": "Export Format",
  "fail": "Fail",
  "fare": "Fare",
  "father": "Father",
  "father_name": "Father Name",
  "father_occupation": "Father Occupation",
  "father_phone": "Father Phone",
  "fee_category": "Fee Category",
  "fee_master": "Fee Master",
  "fee_type": "Fees Type",
  "fees": "Fees",
  "fees_category": "Fees Category",
  "fees_category_list": "Fees Category List",
  "fees_code": "Fees Code",
  "fees_collection": "Fees Collection",
  "fees_collection_&_expenses_for": "Fees Collection & Expenses For",
  "fees_collection_&_expenses_for_session": "Fees Collection & Expenses For Session",
  "fees_collection_details": "Fees Collection Details",
  "fees_discount": "Fees Discount",
  "fees_discount_list": "Fees Discount List",
  "fees_group": "Fees Group",
  "fees_group_list": "Fees Group List",
  "fees_master": "Fees Master",
  "fees_master_list": "Fees Master List",
  "fees_receipt": "Fees Receipt",
  "fees_statement": "Fees Statement",
  "fees_submission": "Fees Submission",
  "fees_subtotal": "Fees Subtotal",
  "fees_type": "Fees Type",
  "fees_type_list": "Fees Type List",
  "female": "Female",
  "fill_mark": "Fill Marks",
  "fine": "Fine",
  "first_name": "First Name",
  "forgot_password": "Forgot Password",
  "full_mark": "Full Marks",
  "full_marks": "Full Marks",
  "gateway_name": "Gateway Name",
  "gender": "Gender",
  "general_settings": "General Setting",
  "generate_pdf": "Generate PDF",
  "grade": "Grade",
  "grade_list": "Grade List",
  "grade_name": "Grade Name",
  "grand_total": "Grand Total",
  "gross_fees": "Gross Fees",
  "group": "Group",
  "guardian_address": "Guardian Address",
  "guardian_details": "Guardian Details",
  "guardian_email": "Guardian Email",
  "guardian_name": "Guardian Name",
  "guardian_occupation": "Guardian Occupation",
  "guardian_phone": "Guardian Phone",
  "guardian_relation": "Guardian Relation",
  "guardians": "Guardians",
  "half_day": "Half Day",
  "hash_key": "Hash Key",
  "holiday": "Holiday",
  "hostel": "Hostel",
  "hostel_-_rooms": "Hostel - Rooms",
  "hostel_list": "Hostel List",
  "hostel_name": "Hostel Name",
  "hostel_room_list": "Hostel Room List",
  "hostel_rooms": "Hostel Rooms",
  "id": "Id",
  "identification": "Identification",
  "if_guardian_address_is_current_address": "If Guardian Address is Current Address",
  "if_guardian_is": "If Guardian Is",
  "if_permanent_address_is_current_address": "If Permanent Address is Current Address",
  "ifsc_code": "IFSC Code",
  "import_excel": "Import Excel",
  "import_student": "Import Student",
  "income": "Income",
  "income_details": "Income Details",
  "income_head": "Income Head",
  "income_head_list": "Income Head List",
  "income_id": "Income Id",
  "income_list": "Income List",
  "income_result": "Income Result",
  "income_search": "Income Search",
  "individual": "Individual",
  "intake": "Intake",
  "inventory": "Inventory",
  "invoice_no": "Invoice Number",
  "ip_address": "IP Address",
  "isbn": "ISBN",
  "isbn_no": "ISBN No",
  "issue": "Issue",
  "issue_book": "Issue Book",
  "issue_by": "Issue By",
  "issue_date": "Issue Date",
  "issue_item": "Issue Item",
  "issue_return": "Issue / Return",
  "issue_to": "Issue To",
  "issued_by": "Issued By",
  "item": "Item",
  "item_category": "Item Category",
  "item_category_list": "Item Category List",
  "item_list": "Item List",
  "item_stock_list": "Item Stock List",
  "item_store": "Item Store",
  "item_store_code": "Item Stock Code",
  "item_store_list": "Item Store List",
  "item_store_name": "Item Store Name",
  "item_supplier": "Item Supplier",
  "item_supplier_list": "Item Supplier List",
  "language": "Language",
  "language_list": "Language List",
  "language_rtl_text_mode": "Language RTL Text Mode",
  "languages": "Languages",
  "last_name": "Last Name",
  "late": "Late",
  "late_with_excuse": "Late With Excuse",
  "leave": "Leave",
  "librarian": "Librarian",
  "librarian_list": "Librarian List",
  "librarian_photo": "Librarian Photo",
  "librarians": "Librarians",
  "library": "Library",
  "library_-_books": "Library - Books",
  "library_book": "Library Book",
  "library_books": "Library Books",
  "library_card_no": "Library Card No",
  "list": "List",
  "local_identification_no": "Local Identification Number",
  "login_credential": "Login Credential",
  "login_details": "Login Details",
  "login_time": "Login Time",
  "login_url": "Login Url",
  "logout": "Logout",
  "male": "Male",
  "manage": "Manage",
  "mark_as_holiday": "Mark As Holiday",
  "marks_grade": "Marks Grade",
  "marks_register": "Marks Register",
  "marks_register_prepared": "Marks Register Prepared",
  "member_id": "Member Id",
  "member_list": "Members List",
  "member_type": "Member Type",
  "members": "Members",
  "merchant_id": "CCAvenue Merchant ID",
  "message": "Message",
  "message_to": "Message To",
  "miscellaneous_details": "Miscellaneous Details",
  "mobile_no": "Mobile Number",
  "mode": "Mode",
  "month": "Month",
  "monthly_expenses": "Monthly Expenses",
  "monthly_fees_collection": "Monthly Fees Collection",
  "mother": "Mother",
  "mother_name": "Mother Name",
  "mother_occupation": "Mother Occupation",
  "mother_phone": "Mother Phone",
  "MSG_91": "MSG91",
  "my_children": "My Children",
  "my_profile": "My Profile",
  "name": "Name",
  "national_identification_no": "National Identification Number",
  "new_password": "New Password",
  "new_username": "New Username",
  "next_session_status": "Next Session Status",
  "no": "No",
  "no_attendance_prepare": "No Attendance Prepared",
  "no_description": "No Description",
  "no_exam_prepare": "No Exam Prepared",
  "no_fees_found": "No Fees Found",
  "no_of_bed": "Number Of Bed",
  "no_of_vehicle": "Number Of Vehicle",
  "no_record_found": "No Record Found",
  "no_result_prepare": "No Result Prepared",
  "no_search_record_found": "No Search Record Found",
  "no_transaction_found": "No Transaction Found",
  "no_transport_fees_found": "No Transport Fees Found",
  "no_vehicle_allotted_to_this_route": "No vehicle allotted to this route",
  "not": "Not",
  "not_scheduled": "Not Scheduled",
  "note": "Note",
  "notice": "Notice",
  "notice_board": "Notice Board",
  "notice_date": "Notice Date",
  "notification_setting": "Notification Setting",
  "notifications": "Notifications",
  "obtain_marks": "Obtain Marks",
  "off": "Off",
  "on": "On",
  "other": "Other",
  "other_discount": "Other Discount",
  "other_download_list": "Other Download List",
  "other_downloads": "Other Downloads",
  "other_download": "Other Download",
  "paid": "Paid",
  "paid_fees": "Paid Fees",
  "parent": "Parent",
  "parent_guardian_detail": "Parent Guardian Detail",
  "partial": "Partial",
  "pass": "Pass",
  "passing_marks": "Passing Marks",
  "password": "Password",
  "payment": "Payment",
  "payment_id": "Payment Id",
  "payment_id_detail": "Payment Id Detail",
  "payment_methods": "Payment Methods",
  "paypal_email": "Paypal Email",
  "paypal_password": "Paypal Password",
  "paypal_setting": "Paypal Setting",
  "paypal_signature": "Paypal Signature",
  "paypal_username": "Paypal Username",
  "payu_money_key": "PayU Money Key",
  "payu_money_salt": "PayU Money Salt",
  "pdf": "PDF",
  "percent": "Percent",
  "percent_from": "Percent From",
  "percent_to": "Percent To",
  "percent_upto": "Percent Upto",
  "percentage": "Percentage",
  "permanent_address": "Permanent Address",
  "phone": "Phone",
  "post_new_message": "Post New Message",
  "postdate": "Post Date",
  "practical": "Practical",
  "present": "Present",
  "previous_school_details": "Previous School Details",
  "print": "Print",
  "print_selected": "Print Selected",
  "profile": "Profile",
  "promote": "Promote",
  "promote_in_session": "Promote In Session",
  "promote_students": "Promote Students",
  "promote_students_in_next_session": "Promote Students In Next Session",
  "publish_date": "Publish Date",
  "publish_on": "Publish On",
  "publisher": "Publisher",
  "qty": "Qty",
  "quantity": "Quantity",
  "quick_links": "Quick Links",
  "rack_no": "Rack No",
  "receipt_no": "Receipt Number",
  "registered_phone_number": "Registered Phone Number",
  "religion": "Religion",
  "report": "Report",
  "report_card": "Report Card",
  "reports": "Reports",
  "reset": "Reset",
  "reset_password": "Reset Password",
  "restore": "Restore",
  "result": "Result",
  "return": "Return",
  "return_date": "Return Date",
  "returned": "Returned",
  "revert": "Revert",
  "role": "Role",
  "roll_no": "Roll Number",
  "room": "Room",
  "room_no": "Room Number",
  "room_no_name": "Room Number / Name",
  "room_type": "Room Type",
  "room_type_list": "Room Type List",
  "route": "Route",
  "route_list": "Route List",
  "route_title": "Route Title",
  "routes": "Routes",
  "rte": "RTE",
  "save": "Save",
  "save_attendance": "Save Attendance",
  "scheduled": "Scheduled",
  "school_code": "School Code",
  "school_logo": "School Logo",
  "school_name": "School Name",
  "search": "Search",
  "search_by_keyword": "Search By Keyword",
  "search_by_student_name": "Search By Student Name, Roll Number, Enroll Number, National Id, Local Id Etc.",
  "search_due_fees": "Search Due Fees",
  "search_expense": "Search Expense",
  "search_fees_payment": "Search Fees Payment",
  "search_income": "Search Income",
  "search_student": "Search Student",
  "search_transaction": "Search Transaction",
  "section": "Section",
  "section_list": "Section List",
  "section_name": "Section Name",
  "sections": "Sections",
  "select": "Select",
  "select_criteria": "Select Criteria",
  "select_csv_file": "Select CSV File",
  "select_image": "Select Image",
  "select_logo": "Select Logo",
  "select_payment_gateway": "Select Payment Gateway",
  "send": "Send",
  "send_email_/_sms": "Send Email / SMS",
  "send_message": "Send Message",
  "send_through": "Send Through",
  "sender_id": "Sender ID",
  "session": "Session",
  "session_list": "Session List",
  "session_setting": "Session Setting",
  "session_start_month": "Session Start Month",
  "show": "Show",
  "sibling": "Sibling",
  "sign_in": "Sign In",
  "smart_school": "Smart School",
  "sms": "SMS",
  "sms_configuration": "SMS Configuration",
  "SMS_country": "SMS Country",
  "sms_gateway_url": "SMS Gateway URL",
  "sms_setting": "SMS Setting",
  "smtp_password": "SMTP Password",
  "smtp_port": "SMTP Port",
  "smtp_security": "SMTP Security",
  "smtp_server": "SMTP Server",
  "smtp_username": "SMTP Username",
  "start_time": "Start Time",
  "status": "Status",
  "store": "Store",
  "stripe_api_secret_key": "Stripe API Secret Key",
  "stripe_publishable_key": "Stripe Publishable Key",
  "student": "Student",
  "student_admission": "Student Admission",
  "student_attendance": "Student Attendance",
  "student_categories": "Student Categories",
  "student_detail": "Student Detail",
  "student_details": "Student Details",
  "student_fees": "Student Fees",
  "student_fees_report": "Student Fees Report",
  "student_information": "Student Information",
  "student_lists": "Students List",
  "attendance_desc": "Track daily check-in/out via QR scan or manual entry",
  "student_id": "Student ID",
  "student_name": "Student Name",
  "student_report": "Student Report",
  "students": "Students",
  "study_material": "Study Material",
  "study_material_list": "Study Material List",
  "subject": "Subject",
  "subject_code": "Subject Code",
  "subject_list": "Subject List",
  "subject_name": "Subject Name",
  "subject_type": "Subject Type",
  "subjects": "Subjects",
  "subject_group": "Subject Group",
  "submit": "Submit",
  "supplier": "Supplier",
  "surrender_membership": "Surrender Membership",
  "syllabus": "Syllabus",
  "syllabus_list": "Syllabus List",
  "system_settings": "System Settings",
  "teacher": "Teacher",
  "teacher_detail": "Teacher Detail",
  "teacher_list": "Teacher List",
  "teacher_name": "Teacher Name",
  "teacher_photo": "Teacher Photo",
  "teacher_subject": "Teacher Subject",
  "teachers": "Teachers",
  "teachers_timetable": "Teachers Timetable",
  "Text_Local": "Text Local",
  "theory": "Theory",
  "time_from": "Time From",
  "time_to": "Time To",
  "timezone": "Timezone",
  "title": "Title",
  "to": "To",
  "total": "Total",
  "total_balance": "Total Balance",
  "total_fees": "Total Fees",
  "total_marks": "Total Marks",
  "total_paid_fees": "Total Paid Fees",
  "total_transport_fees": "Total Transport Fees",
  "transaction_from": "Transaction From",
  "transaction_report": "Transaction Report",
  "transport": "Transport",
  "transport_-_routes": "Transport - Routes",
  "transport_fees": "Transport Fees",
  "transport_fees_details": "Transport Fees Details",
  "transport_routes": "Transport Routes",
  "twilio_account_sid": "Twilio Account SID",
  "twilio_sms_gateway": "Twilio SMS Gateway",
  "type": "Type",
  "unpaid": "Unpaid",
  "upload": "Upload",
  "upload_content": "Upload Content",
  "upload_date": "Upload Date",
  "upload_documents": "Upload Documents",
  "upload_from_local_directory": "Upload From Local Directory",
  "url": "URL",
  "user_agent": "User Agent",
  "user_log": "User Log",
  "user_login": "User Login",
  "user_name": "User Name",
  "user_type": "User Type",
  "username": "Username",
  "users": "Users",
  "vehicle": "Vehicle",
  "vehicle_list": "Vehicle List",
  "vehicle_model": "Vehicle Model",
  "vehicle_no": "Vehicle Number",
  "vehicle_route_list": "Vehicle Route List",
  "vehicle_routes": "Vehicle Routes",
  "vehicles": "Vehicles",
  "view": "View",
  "view_detail": "View Detail",
  "view_schedule": "View Schedule",
  "view_status": "View Status",
  "visibility": "Visibility",
  "visible_to_all": "Visible To All",
  "working_key": "CCAvenue Working Key",
  "year_made": "Year Made",
  "yes": "Yes",
  "you_can_edit_record": "You Can Edit Record",
  "access_denied": "Access Denied!",
  "account_title": "Account Title",
  "action_taken": "Action Taken",
  "add_event": "Add Event",
  "add_gallery": "Add Gallery",
  "add_homework": "Add Homework",
  "add_house": "Add Student House",
  "add_images": "Add Images",
  "add_media": "Add Media",
  "add_menu": "Add Menu",
  "add_menu_item": "Add Menu Item",
  "add_notice": "Add News",
  "add_page": "Add Page",
  "add_staff": "Add Staff",
  "add_staff_member": "Add Staff Member",
  "admission_enquiry": "Admission Enquiry",
  "admission_year": "Admission Year",
  "apply": "Apply",
  "apply_leave": "Apply Leave",
  "approve_leave_request": "Approve Leave Request",
  "approved": "Approved",
  "assign_class_teacher": "Assign Class Teacher",
  "assign_permission": "Assign Permission",
  "available": "Available",
  "background_image": "Background Image",
  "bank_account_details": "Bank Account Details",
  "bank_branch_name": "Bank Branch Name",
  "banner_images": "Banner Images",
  "basic_salary": "Basic Salary",
  "blood_group": "Blood Group",
  "body": "Body",
  "body_text": "Body Text",
  "calculate": "Calculate",
  "calendar": "Calendar",
  "call_duration": "Call Duration",
  "call_type": "Call Type",
  "call_us": "Call Us",
  "card": "Card",
  "certificate": "Certificate",
  "class_teacher": "Class Teacher",
  "class_teacher_list": "Class Teacher List",
  "color": "Color",
  "complain": "Complaint",
  "complain_by": "Complain By",
  "complain_type": "Complain Type",
  "complete": "Complete",
  "computer_generated_payslip": "This payslip is computer generated hence no signature is required.",
  "confirm": "Confirm",
  "contact": "Contact",
  "contract_type": "Contract Type",
  "created_by": "Created By",
  "cron_secret_key": "Cron Secret Key",
  "custom": "Custom",
  "date_of_joining": "Date Of Joining",
  "date_of_leaving": "Date Of Leaving",
  "days": "Days",
  "deduction": "Deduction",
  "delete_confirm": "Delete Confirm?",
  "department": "Department",
  "design": "Design",
  "designation": "Designation",
  "disable": "Disable",
  "disabled_staff": "Disabled Staff",
  "disabled_students": "Disabled Students",
  "earning": "Earning",
  "edit_admission_enquiry": "Edit Admission Enquiry",
  "edit_event": "Edit Event",
  "edit_gallery": "Edit Gallery",
  "edit_homework": "Edit Homework",
  "edit_house": "Edit Student House",
  "edit_menu_item": "Edit Menu Item",
  "edit_notice": "Edit Notice",
  "edit_page": "Edit Page",
  "email_us": "Email Us",
  "emergency_contact_number": "Emergency Contact Number",
  "enable": "Enable",
  "end": "End",
  "enquiry": "Enquiry",
  "enter_keyword": "Enter Keyword...",
  "epf_no": "EPF No",
  "evaluate_homework": "Evaluate Homework",
  "evaluated_by": "Evaluated By",
  "evaluation_date": "Evaluation Date",
  "evaluation_report": "Evaluation Report",
  "event": "Event",
  "event_end": "Event End",
  "event_list": "Event List",
  "event_start": "Event Start",
  "events": "Events",
  "external_url": "External URL",
  "external_url_address": "External URL Address",
  "facebook_url": "Facebook URL",
  "favicon": "Favicon",
  "feature": "Feature",
  "featured_image": "Featured Image",
  "fee_due_days": "Fees Due Days",
  "feedback": "Feedback",
  "fees_carry_forward": "Fees Carry Forward",
  "follow_up": "Follow Up",
  "follow_up_admission_enquiry": "Follow Up Admission Enquiry",
  "follow_up_date": "Follow Up Date",
  "follow_us": "Follow Us",
  "footer": "Footer",
  "footer_center_text": "Footer Center Text",
  "footer_left_text": "Footer Left Text",
  "footer_right_text": "Footer Right Text",
  "footer_text": "Footer Text",
  "from_title": "From Title",
  "front_cms": "Front CMS",
  "front_cms_setting": "Front CMS Settings",
  "front_office": "Front Office",
  "gallery": "Gallery",
  "gallery_images": "Gallery Images",
  "gallery_list": "Gallery List",
  "generate": "Generate",
  "google_analytics": "Google Analytics Tracking Code",
  "google_plus_url": "Google Plus",
  "gross_salary": "Gross Salary",
  "guardian": "Guardian",
  "guardian_report": "Guardian Report",
  "header": "Header",
  "header_center_text": "Header Center Text",
  "header_left_text": "Header Left Text",
  "header_right_text": "Header Right Text",
  "height": "Height",
  "homework": "Homework",
  "homework_already_evaluated": "Homework already evaluated, now you can update evaluation.",
  "homework_completed": "Homework Completed",
  "homework_date": "Homework Date",
  "homework_evaluation": "Homework Evaluation",
  "homework_list": "Homework List",
  "homework_settings": "Homework Settings",
  "house": "Student House",
  "house_list": "Student House List",
  "human_resource": "Human Resource",
  "icard": "ID Card",
  "in_time": "In Time",
  "incoming": "Incoming",
  "incomplete": "Incomplete",
  "instagram_url": "Instagram URL",
  "joining_letter": "Joining Letter",
  "last_follow_up_date": "Last Follow Up Date",
  "latest_news": "Latest News",
  "leave_request": "Leave Request",
  "leave_type": "Leave Type",
  "leaves": "Leaves",
  "linkedin_url": "Linkedin URL",
  "links": "Links",
  "login": "Login",
  "logo": "Logo",
  "marital_status": "Marital Status",
  "measurement_date": "As on Date",
  "media_manager": "Media Manager",
  "media_name": "Media Name",
  "media_path": "Media Path",
  "media_size": "Media Size",
  "media_type": "Media Type",
  "menu": "Menu",
  "menu_item": "Menu Item",
  "menu_item_list": "Menu Item List",
  "menu_list": "Menu List",
  "menus": "Menus",
  "meta_description": "Meta Description",
  "meta_keyword": "Meta Keyword",
  "meta_title": "Meta Title",
  "module": "Module",
  "modules": "Modules",
  "net_salary": "Net Salary",
  "next_follow_up_date": "Next Follow Up Date",
  "not_authoried": "You are not authorised to access this page/action.",
  "notice_list": "News List",
  "number_of_child": "Number Of Child",
  "number_of_leaves": "Number of Leaves",
  "number_of_person": "Number Of Person",
  "open_in_new_tab": "Open In New Tab",
  "option": "Option",
  "other_documents": "Other Documents",
  "out_time": "Out Time",
  "outgoing": "Outgoing",
  "page": "Page",
  "page_list": "Page List",
  "page_type": "Page Type",
  "payroll": "Payroll",
  "payroll_settings": "Payroll Settings",
  "statutory_report": "Statutory Register",
  "attendance_advanced": "Advanced Attendance",
  "hr_notifications": "Notifications",
  "details_for": "Details For",
  "payroll_report": "Payroll Report",
  "payslip": "Payslip",
  "payslip_for_the_period_of": "Payslip for the period of",
  "pending_task": "pending task.",
  "permission": "Permission",
  "phone_call_log": "Phone Call Log",
  "photo": "Photo",
  "pinterest_url": "Pinterest URL",
  "postal_dispatch": "Postal Dispatch",
  "postal_receive": "Postal Receive",
  "previous_balance_already_forwarded": "Previous balance already forwarded, you can only update now.",
  "previous_session_balance_fees": "Previous Session Balance Fees",
  "private": "Private",
  "proceed_to_pay": "Proceed To Pay",
  "protected": "Protected",
  "public": "Public",
  "purpose": "Purpose",
  "qualification": "Qualification",
  "reason": "Reason",
  "reference": "Reference",
  "reference_no": "Reference No",
  "regenerate": "Regenerate",
  "remove": "Remove",
  "report_for": "Report For",
  "resignation_letter": "Resignation Letter",
  "response": "Response",
  "resume": "Resume",
  "roles_permissions": "Roles Permissions",
  "add_role": "Add Role",
  "role_name": "Role Name",
  "role_added": "Role added successfully",
  "role_updated": "Role updated successfully",
  "role_deleted": "Role deleted successfully",
  "staff_count": "Staff Count",
  "system_role": "System Role",
  "custom_role": "Custom Role",
  "assign_permissions": "Assign Permissions",
  "select_all": "Select All",
  "permission_updated": "Permissions updated successfully",
  "permission_groups": "permission groups",
  "total_permissions": "total permissions",
  "confirm_delete_role": "Delete Role",
  "cannot_delete_system_role": "System roles cannot be deleted",
  "can_view": "View",
  "can_add": "Add",
  "can_edit": "Edit",
  "can_delete": "Delete",
  "back": "Back",
  "sample_message": "Sample Message",
  "search_by_file_name": "Search By File Name",
  "search_by_file_type": "Filter By File Type",
  "search_by_staff": "Search By Staff ID, Name, Role etc...",
  "seo_detail": "SEO Detail",
  "setup_front_office": "Front Office Setup",
  "sidebar": "Sidebar",
  "sidebar_option": "Sidebar Option",
  "sidebar_setting": "Sidebar Setting",
  "signature": "Signature",
  "social_media": "Social Media",
  "source": "Source",
  "staff": "Staff",
  "staff_attendance": "Staff Attendance",
  "biometric_management": "Biometric Management",
  "staff_attendance_report": "Staff Attendance Report",
  "staff_directory": "Staff Directory",
  "organization": "Organization",
  "staff_id": "Staff ID",
  "staff_member_list": "Staff Member List",
  "standard": "Standard",
  "start": "Start",
  "student_history": "Student History",
  "student_transport_report": "Student Transport Report",
  "submission_date": "Submission Date",
  "submitted_by": "Submitted By",
  "summary": "Summary",
  "system": "System",
  "task": "Task",
  "tax": "Tax",
  "teacher_restricted_mode": "Teacher Restricted Mode",
  "timeline": "Timeline",
  "to_do": "To Do",
  "to_title": "To Title",
  "today_you_have": "Today you have",
  "twitter_url": "Twitter URL",
  "upload_your_file": "Upload Your File",
  "upload_youtube_video": "Upload Youtube Video",
  "used": "Used",
  "venue": "Venue",
  "visible": "Visible to this person",
  "visitor": "Visitor",
  "visitor_book": "Visitor Book",
  "weight": "Weight",
  "what_is_new_in": "What's new in",
  "width": "Width",
  "work_experience": "Work Experience",
  "work_location": "Location",
  "work_shift": "Work Shift",
  "year": "Year",
  "years": "Years",
  "youtube_url": "YouTube URL",
  "abs": "ABS",
  "account_id": "Account ID",
  "account_type": "Account Type",
  "address_phone_email": "Address/Phone/Email",
  "admission_form_disable_please_contact_to_administrator": "Admission Form Disable Please Contact to Administrator",
  "admission_in_this_duration": " Total Admission in this duration",
  "admission_no_digit": "Admission No Digit",
  "admission_no_prefix": "Admission No Prefix",
  "admission_start_from": "Admission Start From",
  "admit": "Admit",
  "admited_alert": "No student admitted in this Class-Section",
  "after": "After",
  "after_number": "After Number",
  "agent": "Agent",
  "already_exists": "Already exists",
  "answer": "Answer",
  "api_id": "Api ID",
  "approve": "Approve",
  "april": "April",
  "are_you_sure": "Are you sure?",
  "are_you_sure_assign_fees_discount": "Are you sure to assign fees discount ?",
  "are_you_sure_delete_record": "Are you sure you want to delete this?",
  "are_you_sure_disable_record": "Are you sure you want to Disable this Record?",
  "are_you_sure_want_to_delete": "Are you sure want to delete",
  "are_you_sure_you_active_account": "Are you sure you active account?",
  "are_you_sure_you_want_to_promote_confirm": "Are you sure you, want to promote confirm?",
  "are_you_sure_you_want_to_submit_this_exam": "Are you sure, you want to submit this exam?",
  "assign": "Assign",
  "attachment": "Attachment",
  "attempt": "Attempt",
  "attempted": "Attempted",
  "attendence": "Attendance",
  "attendence_type_id": "Attendance Type Id",
  "audit": "Audit",
  "august": "August",
  "auto_staff_id": "Auto Staff ID",
  "available_out_of": "Available out of",
  "awaiting": "Awaiting",
  "background": "Background",
  "bank": "Bank",
  "basic_system": "General Purpose (Pass/Fail)",
  "batch": "Batch",
  "before": "Before",
  "before_number": "Before Number",
  "belong_to": "Belong To",
  "biometric": "Biometric",
  "birth": "Birth",
  "both": "Both",
  "boys": "Boys",
  "bulk": "Bulk",
  "by": "By",
  "candidates": "Candidate's",
  "cannot_delete_this_event": "Cannot Delete this event.",
  "card_no_already_exists": "Card no already exists",
  "center": "Center",
  "certificate_name": "Certificate Name",
  "certificate_text": "Certificate Text",
  "certificated_that": "Certificated That",
  "character": "Character",
  "chat": "Chat",
  "chats": "Chats",
  "choose_a_file": "Choose a file",
  "click": "Click",
  "close": "Close",
  "code": "Code",
  "coll_grade_system": "College Based Grading System",
  "collect": "Collect",
  "collect_by": "Collect By",
  "coma": "Coma",
  "combine": "Combine",
  "combined": "Combined",
  "comment": "Comment",
  "complaint": "Complaint",
  "complaint_type": "Complaint Type",
  "confirm_status": "Confirm Status?",
  "consolidate": "Consolidate",
  "consolidated": "Consolidated",
  "contact_number": "Phone Number",
  "converted": "Converted",
  "correct": "Correct",
  "count": "Count",
  "country_code": "Country Code",
  "credit": "Credit",
  "d_o_b": "D.O.B",
  "dead": "Dead",
  "december": "December",
  "delete_message": "Record Delete Successfully",
  "deposit_amount_can_not_be_less_han_zero": "Deposit amount can not be less than zero",
  "device": "Device",
  "devices": "Devices",
  "digit_long": "digit long",
  "disapprove": "Disapprove",
  "division": "Division",
  "do": "Do",
  "do_you_want_to_proceed": "Do you want to proceed?",
  "driver": "Driver",
  "due": "Due",
  "duplicate": "Duplicate",
  "duplicate_entry": "Duplicate entry",
  "duration": "Duration",
  "enrolled": "Enrolled",
  "enter": "Enter",
  "evaluation_completed_message": "Homework Evaluation completed Successfully.",
  "exam_absent": "ABS",
  "exam_connected_successfully": "Exam connected successfully",
  "exam_from_date": "Exam From Date",
  "exam_marks": "Exam Marks",
  "exam_meassage_student": " You are not member of this exam, please contact to administrator.",
  "exam_mother_name": "Mother Name",
  "exam_to_date": "Exam To Date",
  "exams": "Exams",
  "exams_subject_may_be_empty_please_check_exam_subjects": "Exams subject may be empty, Please check exam subjects",
  "expense": "Expense",
  "extension_not_allowed": "Extension not allowed",
  "fathers": "Fathers",
  "february": "February",
  "fee_discount": "Fee Discount",
  "fee_group": "Fee Group",
  "fee_groups_feetype_id": "Fee groups feetype id",
  "feegroup": "Fee Group",
  "fees_discount_id": "Fees Discount Id",
  "fees_payment_id": "Fees Payment Id",
  "feetype": "Fee Type",
  "field": "Field",
  "field_belongs_to": "Field Belongs to",
  "field_name": "Field Name",
  "field_values": "Field Values",
  "field_values_seprate_by_comma": "Field Values (Separate By Comma)",
  "fields": "Fields",
  "fields_values_required": "Fields Values required.",
  "file_size_shoud_be_less_than": "File size should be less than ",
  "file_type_not_allowed": "File type not allowed",
  "file_upload_successfully": "File upload successfully",
  "finance": "Finance",
  "first": "First",
  "fix": "Fix",
  "for": "For",
  "friday": "Friday",
  "from": "From",
  "generated": "Generated",
  "girls": "Girls",
  "gpa": "GPA Grading System",
  "grand": "Grand",
  "grand_total_in_words": "Grand total in words",
  "grid_boostrap": "Grid (Bootstrap Column eg. 6) - Max is 12",
  "heading": "Heading",
  "hours": "Hours",
  "image": "Image",
  "image_deleted_successfully": "Image deleted successfully",
  "import": "Import",
  "important": "Important",
  "included": "Included",
  "incorrect": "Incorrect",
  "inserted": "Inserted",
  "invalid_email_or_user_type": "Invalid Email or User Type",
  "invalid_file_type": "Invalid File type",
  "invalid_link": "Invalid Link",
  "invalid_username_or_password": "Invalid Username or Password",
  "invoice": "Invoice",
  "issued": "Issued",
  "issued_out_of": "Issued out of",
  "it_here": "it here",
  "january": "January",
  "jpg_jpeg_png": "JPG | JPEG | PNG",
  "july": "July",
  "june": "June",
  "key": "Key",
  "last": "Last",
  "last_12_month": "Last 12 Months",
  "last_3_month": "Last 3 Months",
  "last_6_month": "Last 6 Months",
  "last_month": "Last Month",
  "last_week": "Last Week",
  "last_year": "Last Year",
  "leads": "Leads",
  "left": "Left",
  "licence": "Licence",
  "link": "Link",
  "log": "Log",
  "logo_file_is_required": "Logo file is required",
  "lost": "Lost",
  "mac": "Mac",
  "made": "Made",
  "map": "Map",
  "march": "March",
  "marks": "Marks",
  "marksheet": "Marksheet",
  "marksheet_body_text": "Appeared in the higher secondary school certificate examination of the board in the year 2020 from (school/centre)** and subject wise marks obtained are as under",
  "marksheet_father_name": "Father / Husband Name",
  "married": "Married",
  "max": "Max.",
  "may": "May",
  "message_sent_successfully": "Message sent successfully",
  "message_successfully_sent": "Message successfully sent",
  "middle": "Middle",
  "min": "Min.",
  "miscellaneous": "Miscellaneous",
  "model": "Model",
  "monday": "Monday",
  "mothers": "Mothers",
  "multiclass": "Multi Class",
  "my": "My",
  "name_already_exists": "Name already exists",
  "name_prefix": "Mr/Ms",
  "new": "New",
  "next": "Next",
  "no_exam_found": "No Exam Found",
  "no_exams_selected": "No Exams Selected",
  "no_of_exams": "No of Exams",
  "no_question_found_please_contact_to_administrator": "No Question Found, Please contact to Administrator.",
  "no_record_selected": "No Record Selected?",
  "no_subject_found": "No Subject Found",
  "none": "None",
  "not_specified": "Not Specified",
  "november": "November",
  "obtain": "Obtain",
  "obtained": "Obtained",
  "obted_by_student": "Opted By Student",
  "october": "October",
  "of": "Of",
  "online": "Online",
  "option_A": "Option A",
  "option_B": "Option B",
  "option_C": "Option C",
  "option_D": "Option D",
  "option_E": "Option E",
  "or": "or",
  "overview": "Overview",
  "paper_code": "Paper Code",
  "pass_in_second_division": "Pass in Second Division",
  "passing": "Passing",
  "passive": "Passive",
  "password_changed_successfully": "Password Changed Successfully",
  "password_not_changed": "Password Not Changed",
  "password_reset_successfully": "Password Reset successfully",
  "pay": "Pay",
  "payslip_already_generated": "Payslip already generated",
  "pdf_xls_doc": "PDF | XLS | DOC",
  "pending": "Pending",
  "percentage_from": "Percentage From",
  "percentage_upto": "Percentage Upto",
  "period": "Period",
  "permanent": "Permanent",
  "phone_number": "Phone Number",
  "place": "Place",
  "platform": "Platform",
  "please_check_exam_subjects": "Exams couldn't be connected, Please check exam subjects",
  "please_check_student_admission_no": "Please Check Student Admission No",
  "please_check_your_email_to_recover_your_password": "Please check your email to recover your password",
  "please_choose_at_least_one_file": "Please choose at least one file",
  "please_select_atleast_two_or_more_exams": "Please select atleast two or more exams",
  "please_select_file": "Please Select file",
  "please_try_again": "Please try again",
  "please_upload_CSV_file_only": "Please upload CSV file only.",
  "point": "Point",
  "points": "Points",
  "previous": "Previous",
  "price": "Price",
  "principal": "Principal",
  "printing": "Printing",
  "probation": "Probation",
  "publish": "Publish",
  "publishable_key": "Publishable key",
  "punch_in": "Punch In",
  "purchase": "Purchase",
  "quality": "Quality",
  "question": "Question",
  "questions": "Questions",
  "rank": "Rank",
  "rate": "Rate",
  "rating": "Rating",
  "record_already_exists": "Record already exists",
  "record_this_action_is_irreversible": "Record, this action is irreversible.",
  "records_found_in_CSV_file_total": "records found in CSV file. Total ",
  "records_imported_successfully": " records imported successfully",
  "remaining": "Remaining",
  "remarks": "Remarks",
  "reminder": "Reminder",
  "required": "Required",
  "reviews": "Reviews",
  "right": "Right",
  "roll": "Roll",
  "roll_no_": "Roll No.",
  "rtl": "RTL",
  "salt": "Salt",
  "saturday": "Saturday",
  "save_and_enroll": "Save And Enroll",
  "school_grade_system": "School Based Grading System",
  "score": "Score",
  "seal_and_signature_of_the_principal": "Seal and signature of the principal",
  "search_text": "Search Text",
  "second": "Second",
  "secret_key": "Secret key",
  "secretary": "Secretary",
  "select_any_user_to_start_your_chat": "Select any user to start your chat",
  "selected": "Selected",
  "send_parent_password": " Send Parent Password",
  "send_student_password": " Send Student Password",
  "seperated": "Separated",
  "seprate": "Separate",
  "september": "September",
  "serial": "Serial",
  "session_changed_successfully": "Session changed successfully",
  "short_code": "Short Code",
  "sign": "Sign",
  "single": "Single",
  "small": "Small",
  "some_students_are_already_added_in_other_session": "Some Students are already added in other session",
  "something_went_wrong": "Something went wrong",
  "something_wrong": "Something wrong",
  "staff_id_auto_generation": "Staff ID Auto Generation",
  "staff_id_digit": "Staff ID Digit",
  "staff_ID_field_is_required": "Staff ID field is required",
  "staff_id_prefix": "Staff ID Prefix",
  "staff_id_start_from": "Staff ID Start From",
  "staff_id_start_from_must_be": "Staff ID start from must be",
  "staff_no_digit": "Staff No Digit",
  "std_dtl_for": "Student Details for",
  "stock": "Stock",
  "student_admission_no_auto_generation": "Student Admission No. Auto Generation",
  "students_are_successfully_promoted": "Students are successfully promoted",
  "students_imported_successfully": "Students imported successfully",
  "sub": "Sub",
  "subjects_already_assigned": "Subjects already assigned",
  "success_message": "Record Saved Successfully",
  "sunday": "Sunday",
  "switch": "Switch",
  "table": "Table",
  "template": "Template",
  "template_id": "Template ID",
  "template_message": "Template Message",
  "the_field_can_not_be_blank": "The  field can not be blank",
  "the_file_field_is_required": "The File field is required",
  "theory_exam_date_time": "Theory Exam Date & Time",
  "third": "Third",
  "this_month": "This Month",
  "this_week": "This Week",
  "this_year": "This Year",
  "thursday": "Thursday",
  "time": "Time",
  "timetable": "Timetable",
  "today": "Today",
  "todays_birtday": "Today's Birthday",
  "trail": "Trail",
  "transfer_to_bank_account": "Transfer to Bank Account",
  "tuesday": "Tuesday",
  "unavailable_quantity": "Unavailable quantity ",
  "unit": "Unit",
  "update": "Update",
  "update_message": "Record Update Successfully",
  "uploaded": "Uploaded",
  "user": "User",
  "validation": "Validation",
  "visiblility": "Visibility",
  "visitors_purpose": "Visitors Purpose",
  "wednesday": "Wednesday",
  "weightage": "Weightage",
  "widowed": "Widowed",
  "wise": "Wise",
  "won": "Won",
  "wrong": "Wrong",
  "you": "You",
  "you_are_now_connected_on_chat": "you are now connected on chat",
  "you_can_use_variables": "You can use variables",
  "your_account_is_disabled_please_contact_to_administrator": "Your account is disabled please contact to administrator",
  "office_copy": "Office Copy",
  "student_copy": "Student Copy",
  "confirm_msg": "Status changed",
  "published": "Published",
  "upto": "Upto",
  "fees_reminder": "Fees Reminder",
  "mobile_app": "Mobile App",
  "print_headerfooter": "Print Header Footer",
  "content": "Content",
  "fee_submission": "Fee Submission",
  "absent_attendence": "Absent Attendance",
  "private_api_key": "Private API Key",
  "private_auth_token": "Private Auth Token",
  "private_salt": "Private Salt",
  "paystack_secret_key": "Paystack Secret Key",
  "razorpay_key_id": "Razorpay Key Id",
  "razorpay_key_secret": "Razorpay Key Secret",
  "contact_no": "Contact Number",
  "contactno": "Contact Number",
  "mobile_app_api_url": "Mobile App API URL",
  "mobile_app_primary_color_code": "Mobile App Primary Color Code",
  "mobile_app_secondary_color_code": "Mobile App Secondary Color Code",
  "edit_app_logo": "Edit App Logo",
  "deposit_amount_can_not_be_less_than_zero": "Deposit amount can not be less than zero",
  "deposit_amount_can_not_be_greater_than_remaining": "Deposit amount can not be greater than remaining",
  "recipient": "Recipient",
  "fees_payment_details": "Fees Payment Details",
  "decription": "Description",
  "pay_with_instamojo": "Pay With Instamojo",
  "pay_with_paystack": "Pay With Paystack",
  "pay_with_razorpay": "Pay With Razorpay",
  "pay_with_paytm": "Pay With Paytm",
  "pay_with_midtrans": "Pay With Midtrans",
  "alumni": "Alumni",
  "manage_alumini": "Manage Alumni",
  "search_by_admission_number": "Search By Admission Number",
  "current_email": "Current Email",
  "current_phone": "Current Phone",
  "profession": "Profession",
  "visibilty_on_CMS": "Visibility on CMS",
  "no_need_to_show": "No Need To Show",
  "event_starting_date": "Event Starting Date",
  "event_ending_date": "Event Ending Date",
  "teacher_status_report": "Teacher Status Report",
  "periodes_summary": "Periods Summary",
  "syllabus_status_report": "Syllabus Status Report",
  "topic": "Topic",
  "lesson": "Lesson",
  "more": "More",
  "lesson_plan": "Lesson Plan",
  "occupation": "Occupation",
  "pass_out_session": "Pass Out Session",
  "manage_lesson_plan": "Manage Lesson Plan",
  "teachers_syllabus": "Teachers Syllabus",
  "teacher_syllabus_status_report": "Teacher Syllabus Status Report",
  "subject_lesson_plan_report": "Subject Lesson Plan Report",
  "sub_topic": "Sub Topic",
  "teaching_method": "Teaching Method",
  "general_objectives": "General Objectives",
  "previous_knowledge": "Previous Knowledge",
  "comprehensive_questions": "Comprehensive Questions",
  "presentation": "Presentation",
  "lecture_youtube_url": "Lecture YouTube URL",
  "lecture_video": "Lecture Video",
  "total_record": "Total Record",
  "event_notification_message": "Event Notification Message",
  "manage_syllabus_status": "Manage Syllabus Status",
  "topic_completion_date": "Topic Completion Date",
  "system_update": "System Update",
  "update_now": "Update Now",
  "updater_instruction": "Would you like update your system, this procedure is irreversible. Before proceed please take complete backup of your file and database.",
  "your": "Your",
  "latest": "Latest",
  "paytm_merchant_id": "Merchant Id",
  "paytm_merchant_key": "Merchant Key",
  "paytm_website": "Website",
  "indusrty_type": "Industry Type",
  "server_key": "Server Key",
  "super_admin": "Super Admin",
  "no_status": "No Status",
  "subject_percentage_based_on_topic": "Subject percentage based on Topic.",
  "app_name": "Prabhak Smart School",
  "is_available_for_update": "is available for update",
  "version": "Version",
  "submitting": "Submitting...",
  "bank_transfer": "Bank Transfer",
  "upi": "UPI",
  "you_are_not_authorised_to_update_lessons": "You are not authorised to update lessons",
  "you_are_not_authorised_to_update_topics": "You are not authorised to update topics",
  "download_excel": "Download Excel",
  "youtube_link": "YouTube Link",
  "download_video": "Download Video",
  "download_attachment": "Download Attachment",
  "select_child": "Select Child",
  "select_and_proceed": "Select & Proceed",
  "no_more_classes_found_in_your_current_session": "Sorry! You are not belonging to any class for current academic session",
  "atleast_one_student_should_be_select": "Atleast one student should be select",
  "read": "Read",
  "please_select_record": "Please select record",
  "should_not_be_empty": "should not be empty",
  "images": "Images",
  "loading": "Loading",
  "error_occured": "Error occurred",
  "you_want_to_enable_this_record": "you want to enable this record",
  "daily_attendance_report": "Daily Attendance Report",
  "ratio": "Ratio",
  "allow": "Allow",
  "editable": "Editable",
  "form": "Form",
  "allowed_edit_form_fields_on_student_profile": "Allowed edit form fields on student profile",
  "whatsapp_url": "WhatsApp URL",
  "middle_name": "Middle Name",
  "consumer_key": "Consumer Key",
  "consumer_secret": "Consumer Secret",
  "vendorid": "Vendor ID",
  "hashkey": "Hashkey",
  "sun": "Sun",
  "mon": "Mon",
  "tue": "Tue",
  "wed": "Wed",
  "thu": "Thu",
  "fri": "Fri",
  "sat": "Sat",
  "auto_result_publish_date": "Auto Result Publish Date",
  "negative_marking": "Negative Marking",
  "display_marks_in_exam": "Display marks in Exam",
  "seach_by_keyword": "Search by keyword",
  "question_type": "Question Type",
  "delete_question": "Delete Question",
  "negative_marks": "Negative Marks",
  "level": "Level",
  "q": "Q",
  "your_marks": "Your Marks",
  "your_remark": "Your Remark",
  "per_page": "Per Page",
  "descriptive": "Descriptive",
  "exam_questions_list": "Exam Questions List",
  "exam_evalution": "Exam Evaluation",
  "question_level": "Question level",
  "field_must_contain_only_numbers": "field must contain only numbers.",
  "import_student_step1": "Your CSV data should be in the format below. The first line of your CSV file should be the column headers as in the table example. Also make sure that your file is UTF-8 to avoid unnecessary encoding problems.",
  "import_student_step2": "If the column you are trying to import is date make sure that is formatted in format Y-m-d (2018-06-06).",
  "import_student_step3": "Duplicate Admission Number (unique) rows will not be imported.",
  "import_student_step4": "For student Gender use Male, Female value.",
  "import_student_step5": "For student Blood Group use O+, A+, B+, AB+, O-, A-, B-, AB- value.",
  "import_student_step6": "For RTE use Yes, No value.",
  "import_student_step7": "For If Guardian Is user father,mother,other value.",
  "import_student_step8": "Category name comes from other table so for category, enter Category Id (Category Id can be found on category page ).",
  "import_student_step9": "Student house comes from other table so for student house, enter Student House Id (Student House Id can be found on student house page ).",
  "import_staff_step1": "Your CSV data should be in the format below. The first line of your CSV file should be the column headers as in the table example. Also make sure that your file is UTF-8 to avoid unnecessary encoding problems.",
  "import_staff_step2": "If the column you are trying to import is date make sure that is formatted in format Y-m-d (2018-06-06).",
  "bulk_sms": "Bulk SMS",
  "mobireach": "Mobi Reach",
  "route_id": "Route Id",
  "this_message_has_been_deleted": "this message has been deleted",
  "new_message": "New Message",
  "write_your_message": "Write your message",
  "you_cannot_delete_your_current_selected_language": "You cannot delete your current selected language.",
  "default_language_cannot_be_deleted": "Default language cannot be deleted.",
  "publish_exam": "Publish Exam",
  "check_on_quiz_message": "In quiz result will be display to student immediately just after exam submission (descriptive question type will be disabled).",
  "quiz": "Quiz",
  "choose": "Choose",
  "captcha": "Captcha",
  "contact_us": "Contact Us",
  "captcha_setting": "Captcha Setting",
  "file_types": "File Types",
  "activity_log": "Activity Log",
  "online_examination": "Tests",
  "show_me_only_my_question": "Show me only my question",
  "id_card_template": "ID Card Template",
  "access_code": "Access Code",
  "setting_for_files": "Setting for Files",
  "allowed_extension": "Allowed Extension",
  "allowed_mime_type": "Allowed MIME type",
  "upload_size_in_bytes": "Upload Size (in Bytes)",
  "setting_for_image": "Setting for Image",
  "file_extension": "File Extension",
  "image_extension": "Image Extension",
  "q_id": "Q. ID",
  "result_publish_date": "Result Publish Date",
  "descriptive_questions": "Descriptive Questions",
  "correct_answer": "Correct Answer",
  "correct_answer_but_not_attempted": "Correct Answer but not attempted",
  "wrong_answer": "Wrong Answer",
  "total_exam_marks": "Total Exam Marks",
  "total_negative_marks": "Total Negative Marks",
  "total_scored_marks": "Total Scored Marks",
  "your_answer": "Your Answer",
  "teacher_remark": "Teacher Remark",
  "result_not_published": "Result Not Published Yet",
  "pp_merchantid": "pp_MerchantID",
  "pp_password": "pp_Password",
  "paypal": "Paypal",
  "stripe": "Stripe",
  "payu": "PayU",
  "ccavenue": "CCAvenue",
  "instamojo": "InstaMojo",
  "paystack": "Paystack",
  "razorpay": "Razorpay",
  "paytm": "Paytm",
  "midtrans": "Midtrans",
  "pesapal": "Pesapal",
  "flutter_wave": "Flutter Wave",
  "ipay_africa": "iPay Africa",
  "jazzcash": "JazzCash",
  "billplz": "Billplz",
  "multinational_payment_gateway": "Multinational Payment Gateway",
  "payment_gateway_for_india": "Payment Gateway for India",
  "payment_gateway_for_afirican_countries": "Payment Gateway for African Countries",
  "payment_gateway_for_indonesia": "Payment Gateway for Indonesia",
  "payment_gateway_for_pakistan": "Payment Gateway for Pakistan",
  "payment_gateway_for_malaysia": "Payment Gateway for Malaysia",
  "api_key": "Api Key",
  "customer_service_email": "Customer Service Email",
  "incorrect_captcha": "Incorrect Captcha",
  "records": "Records",
  "random_question": "Random Question Order",
  "import_question": "Import Question",
  "attach_file": "Attach File",
  "exam_from": "Exam From",
  "exam_to": "Exam To",
  "exam_publish": "Exam Publish",
  "register_your_android_app": "Register Your Android App",
  "pay_with_billplz": "Pay with Billplz",
  "pay_with_flutterwave": "Pay with Flutter Wave",
  "pay_with_pesapal": "Pay with Pesapal",
  "pay_with_ipayafrica": "Pay with iPayAfrica",
  "pay_with_jazzcash": "Pay with JazzCash",
  "you_have_submitted_the_exam": "You have submitted the Exam",
  "evaluation": "Evaluation",
  "fees_list": "fees_list",
  "processing": "Processing",
  "start_day_of_week": "Start day of  week",
  "are_you_sure_want_to_make_current_backup": "Are you sure want to make current backup?",
  "are_you_sure_want_to_delete_backup": "Are you sure want to delete backup?",
  "are_you_sure_want_to_restore_backup?": "Are you sure want to restore backup?",
  "fee_master_combination_already_exists": "Fee Master Combination already Exists",
  "monthly_amount": "Monthly Amount",
  "smtp_auth": "SMTP Auth",
  "please_select_student": "Please select student",
  "generate_rank": "Generate Rank",
  "please_wait": "Please wait",
  "are_you_sure_to_delete_this": "Are you sure to delete this",
  "mark_completed_successfully": "Mark Completed Successfully.",
  "cannot_mark_complete_this_event": "Cannot Mark Complete this event.",
  "record_deleted_successfully": "Record deleted successfully",
  "are_you_sure_you_want_to_delete": "Are you sure you want to delete ?",
  "are_you_sure_you_deactive_account": "Are you sure you deactive account?",
  "status_change_successfully": "Status change successfully",
  "online_examination_publish_exam": "Online examination publish exam",
  "online_examination_publish_result": "Online examination publish result",
  "no_student_selected": "No Student Selected",
  "alumini_student_for_passout_session": "Alumini Student For Passout Session",
  "total_admission_in_this_duration": "Total Admission in this duration",
  "teacher_time_table": "Teacher Time Table",
  "are_you_sure_you_want_to_disable_this_student": "Are you sure you want to disable this student.",
  "are_you_sure_you_want_to_remove_sibling": "Are you sure you, want to remove sibling ?",
  "quality_points": "Quality Points",
  "consolidated_results": "Consolidated results",
  "exam_rank": "Exam Rank",
  "exam_not_submitted": "Exam Not Submitted",
  "rank_has_already_generated_you_can_update_rank": "Rank has already generated, you can update rank.",
  "exam_submitted": "Exam Submitted",
  "exam_rank_not_generated": "Exam Rank not Generated.",
  "add_to_do": "Add To Do",
  "add_task": "Add Task",
  "edit_task": "Edit Task",
  "to_do_list": "To Do List",
  "pay_with_ccavenue": "Pay with CCAvenue",
  "pay_with_paypal": "Pay with Paypal",
  "pay_with_payu": "Pay with PayU",
  "add_new_event": "Add New Event",
  "are_you_sure_you_want_to_revert_this_record": "Are you sure you want to revert this record",
  "are_you_sure_want_to_revert": "Are you sure want to revert",
  "discount_this_action_is_irreversible": "discount, this action is irreversible.",
  "invoice_this_action_is_irreversible": "invoice, this action is irreversible.",
  "please_choose_a_file_to_upload": "Please choose a file to upload.",
  "android_app_purchase_code_already_registered": "Android App Purchase Code already registered",
  "please_check": "Please check",
  "for_latest_version_update": "for latest version update.",
  "awaited": "Awaited",
  "print_header_footer": "Print Header & Footer",
  "no_image_uploaded": "No header image uploaded",
  "header_image_note": "Header image upload requires the file upload module. The current image shown above is what will print.",
  "characters": "characters",
  "failed_to_load": "Failed to load data",
  "is_required": "is required",
  "server_error": "Server error",
  "configure_public_website": "Configure your school's public-facing website",
  "enable_front_cms": "Enable Front CMS (Public Website)",
  "select_theme": "Select Theme",
  "rtl_mode": "RTL Mode (Right-to-Left)",
  "branding": "Branding",
  "upload_logo": "Upload Logo",
  "upload_favicon": "Upload Favicon",
  "choose_file": "Choose File",
  "social_media_urls": "Social Media URLs",
  "contact_emails": "Contact Emails",
  "contact_us_email": "Contact Us Email",
  "complain_form_email": "Complaint Form Email",
  "contact_email_hint": "Emails from the contact form will be sent here",
  "complain_email_hint": "Emails from the complaint form will be sent here",
  "sidebar_options": "Sidebar Widgets",
  "enable_sidebar": "Show sidebar on public pages",
  "footer_analytics": "Footer & Analytics",
  "footer_text_placeholder": "Enter the text to display in the website footer...",
  "ga_hint": "Paste your Google Analytics tracking ID or GA4 measurement ID",
  "cms_settings_saved": "CMS settings saved successfully",
  "upcoming_events": "Upcoming Events",
  "complain_form": "Complaint Form",
  "upload_images": "Upload Images",
  "drag_drop_upload": "Drag & drop files here or click to browse",
  "add_video": "Add Video",
  "file_type": "File Type",
  "file_size": "File Size",
  "search_media": "Search media...",
  "no_media_found": "No media found",
  "confirm_delete_media": "Are you sure you want to delete this media?",
  "upload_success": "Upload successful",
  "video_added": "Video added successfully",
  "all_media": "All",
  "videos": "Videos",
  "event_date": "Event Date",
  "event_venue": "Event Venue",
  "start_date": "Start Date",
  "end_date": "End Date",
  "create_event": "Create Event",
  "no_events_found": "No events found",
  "notices": "Notices",
  "create_notice": "Create Notice",
  "no_notices_found": "No notices found",
  "select_from_media": "Select from Media",
  "no_banner_images": "No banner images added yet",
  "galleries": "Galleries",
  "select_images": "Select Images",
  "selected_images": "Selected Images",
  "create_gallery": "Create Gallery",
  "no_galleries_found": "No galleries found",
  "pages": "Pages",
  "content_category": "Content Category",
  "is_homepage": "Is Homepage",
  "create_page": "Create Page",
  "no_pages_found": "No pages found",
  "open_new_tab": "Open in New Tab",
  "drag_to_reorder": "Drag to reorder",
  "link_to_page": "Link to Page",
  "menu_group": "Menu Group",
  "parent_item": "Parent Item",
  "no_menus_found": "No menus found",
  "manage_items": "Manage Items",
  "set_as_featured": "Set as Featured",
  "meta_keywords": "Meta Keywords",
  "seo_settings": "SEO Settings",
  "slug": "Slug",
  "home": "Home",
  "read_more": "Read More",
  "our_gallery": "Our Gallery",
  "all_rights_reserved": "All Rights Reserved",
  "back_to_top": "Back to Top",
  "view_all": "View All",
  "no_results": "No results found",
  "back_to": "Back to",
  "stay_updated_with_events": "Stay updated with upcoming school events",
  "latest_announcements": "Latest announcements and updates",
  "back_to_gallery": "Back to Gallery",
  "welcome": "Welcome",
  "certificate_templates": "Certificate Templates",
  "generate_certificate": "Generate Certificate",
  "add_certificate": "Add Certificate",
  "edit_certificate": "Edit Certificate",
  "left_header": "Left Header",
  "center_header": "Center Header",
  "right_header": "Right Header",
  "left_footer": "Left Footer",
  "center_footer": "Center Footer",
  "right_footer": "Right Footer",
  "header_height": "Header Height",
  "content_height": "Content Height",
  "footer_height": "Footer Height",
  "content_width": "Content Width",
  "enable_student_image": "Enable Student Image",
  "image_height": "Image Height",
  "available_placeholders": "Available Placeholders",
  "custom_placeholders": "Custom Placeholders",
  "click_to_insert": "Click to insert",
  "page_size": "Page Size",
  "orientation": "Orientation",
  "landscape": "Landscape",
  "portrait": "Portrait",
  "deselect_all": "Deselect All",
  "no_students_found": "No students found",
  "generate_selected": "Generate Selected",
  "student_id_card": "Student ID Card",
  "student_id_cards": "Student ID Cards",
  "staff_id_card": "Staff ID Card",
  "staff_id_cards": "Staff ID Cards",
  "add_template": "Add Template",
  "edit_template": "Edit Template",
  "template_name": "Template Name",
  "upload_background": "Upload Background",
  "upload_signature": "Upload Signature",
  "enable_photo": "Enable Photo",
  "show_name": "Show Name",
  "show_father_name": "Show Father Name",
  "show_mother_name": "Show Mother Name",
  "show_admission_no": "Show Admission No",
  "show_roll_no": "Show Roll No",
  "show_class": "Show Class",
  "show_section": "Show Section",
  "show_dob": "Show Date of Birth",
  "show_blood_group": "Show Blood Group",
  "show_address": "Show Address",
  "show_phone": "Show Phone",
  "show_gender": "Show Gender",
  "verify_certificate": "Verify Certificate",
  "certificate_no": "Certificate No",
  "enter_certificate_number": "Enter certificate number",
  "verify": "Verify",
  "verified": "Verified",
  "invalid_certificate": "Invalid Certificate",
  "certificate_details": "Certificate Details",
  "issued_to": "Issued To",
  "manage_alumni": "Manage Alumni",
  "alumni_list": "Alumni List",
  "alumni_events": "Alumni Events",
  "event_title": "Event Title",
  "event_description": "Event Description",
  "event_from": "Event From",
  "event_to": "Event To",
  "current_occupation": "Current Occupation",
  "preview": "Preview",
  "design_mode": "Design Mode",
  "generate_mode": "Generate Mode",
  "no_records_found": "No records found",
  "success": "Success",
  "error": "Error",
  "confirm_delete": "Are you sure you want to delete?",
  "saved_successfully": "Saved successfully",
  "deleted_successfully": "Deleted successfully",
  "staff_list": "Staff List",
  "show_department": "Show Department",
  "show_designation": "Show Designation",
  "show_staff_id": "Show Staff ID",
  "show_email": "Show Email",
  "crop_image": "Crop Image",
  "print_id_card": "Print ID Card",
  "item_categories": "Item Categories",
  "item_stores": "Item Stores",
  "item_suppliers": "Item Suppliers",
  "items": "Items",
  "add_stock": "Add Stock",
  "issue_items": "Issue Items",
  "category_name": "Category Name",
  "enter_category_name": "Enter category name",
  "category_name_required": "Category name is required",
  "store_name": "Store Name",
  "enter_store_name": "Enter store name",
  "store_name_required": "Store name is required",
  "store_code": "Store Code",
  "supplier_name": "Supplier Name",
  "supplier_name_required": "Supplier name is required",
  "item_name": "Item Name",
  "select_category": "Select Category",
  "select_item": "Select Item",
  "select_supplier": "Select Supplier",
  "select_store": "Select Store",
  "added_stock": "Added Stock",
  "purchase_price": "Purchase Price",
  "fill_required_fields": "Please fill all required fields",
  "select_role": "Select Role",
  "select_staff": "Select Staff",
  "total_items": "Total Items",
  "total_stock_value": "Total Stock Value",
  "currently_issued": "Currently Issued",
  "low_stock": "Low Stock",
  "low_stock_items": "Low Stock Items",
  "no_low_stock_items": "No low stock items",
  "top_issued_items": "Top Issued Items",
  "threshold": "Threshold",
  "inventory_settings": "Inventory Settings",
  "low_stock_threshold": "Low Stock Threshold",
  "low_stock_threshold_help": "Alert when available quantity drops below this value",
  "allow_negative_stock": "Allow Negative Stock",
  "require_attachment": "Require Attachment on Stock Entry",
  "save_settings": "Save Settings",
  "saved": "Saved!",
  "book_title_required": "Book title is required",
  "price_per_unit": "Price Per Unit",
  "post_date": "Post Date",
  "recent_books": "Recent Books",
  "import_csv": "Import CSV",
  "records_imported": "records imported",
  "total_books": "Total Books",
  "library_value": "Library Value",
  "total_members": "Total Members",
  "overdue": "Overdue",
  "overdue_books": "Overdue Books",
  "no_overdue_books": "No overdue books!",
  "popular_books": "Popular Books",
  "search_member": "Search member...",
  "card_no": "Card No",
  "back_to_members": "Back to Members",
  "member": "Member",
  "select_book": "Select Book",
  "issued_books": "Issued Books",
  "enter_card_no": "Enter card number",
  "search_to_find_students": "Search to find students",
  "member_added": "Member added successfully",
  "issue_report": "Issue Report",
  "return_report": "Return Report",
  "overdue_report": "Overdue Report",
  "from_date": "From Date",
  "to_date": "To Date",
  "load_overdue": "Load Overdue",
  "click_search_to_view_report": "Click search to view report",
  "days_overdue": "Days Overdue",
  "library_settings": "Library Settings",
  "fine_per_day": "Fine Per Day",
  "fine_per_day_help": "Amount charged per day for overdue books",
  "max_books_per_member": "Max Books Per Member",
  "max_books_help": "Maximum number of books a member can borrow at once",
  "default_return_days": "Default Return Days",
  "default_return_days_help": "Auto-set due date this many days from issue date",
  "fine_currency_symbol": "Fine Currency Symbol",
  "no_data": "No data available",
  "select_class": "Select Class",
  "member_name": "Member Name",
  "analytics": "Analytics",
  "analytics_dashboard": "Analytics Dashboard",
  "ai_doubts": "AI Doubts",
  "ai_usage": "AI Usage",
  "ai_doubts_usage": "AI Doubts & Usage",
  "risk_scores": "Risk Scores",
  "engagement": "Engagement",
  "approval_queue": "Approval Queue",
  "select_teacher": "Select Teacher",
  "weekly_lesson_plan": "Weekly Lesson Plan",
  "add_syllabus": "Add Syllabus",
  "edit_syllabus": "Edit Syllabus",
  "syllabus_details": "Syllabus Details",
  "video_upload": "Video Upload",
  "document_upload": "Document Upload",
  "video_settings": "Video Settings",
  "player_settings": "Player Settings",
  "total_doubts": "Total Doubts",
  "approval_rate": "Approval Rate",
  "active_students": "Active Students",
  "avg_response_time": "Avg Response Time",
  "total_tokens": "Total Tokens",
  "estimated_cost": "Estimated Cost",
  "understanding_checks": "Understanding Checks",
  "hardest_topics": "Hardest Topics",
  "most_active_students": "Most Active Students",
  "misuse_flagged": "Misuse Flagged",
  "at_risk_students": "At-Risk Students",
  "days_inactive": "Days Inactive",
  "avg_coverage": "Avg Coverage",
  "check_fail_rate": "Check Fail Rate",
  "grant_bonus": "Grant Bonus",
  "reset_misuse": "Reset Misuse",
  "learning_velocity": "Learning Velocity",
  "concept_mastery": "Concept Mastery",
  "doubt_complexity_trends": "Doubt Complexity Trends",
  "student_journey": "Student Journey",
  "study_heatmap": "Study Heatmap",
  "attention_span": "Attention Span",
  "prev_week": "Previous Week",
  "next_week": "Next Week",
  "no_timetable": "No timetable entries found",
  "rejected": "Rejected",
  "confused": "Confused",
  "understood": "Understood",
  "mastered": "Mastered",
  "student_learning": "Student Learning",
  "risk_alerts": "Risk & Alerts",
  "completion_rate": "Completion Rate",
  "avg_watch_time": "Avg Watch Time",
  "content_viewed": "Content Viewed",
  "video_completion": "Video Completion",
  "upload_video": "Upload Video",
  "upload_document": "Upload Document",
  "linked_videos": "Linked Videos",
  "no_videos": "No videos linked",
  "drag_drop_video": "Drag & drop video file here or click to browse",
  "drag_drop_document": "Drag & drop document here or click to browse",
  "allow_seek": "Allow Seek",
  "allow_pause": "Allow Pause",
  "allow_speed_change": "Allow Speed Change",
  "show_controls": "Show Controls",
  "enable_watermark": "Enable Watermark",
  "require_completion": "Require Completion",
  "max_replays": "Max Replays",
  "watermark_text": "Watermark Text",
  "watermark_position": "Watermark Position",
  "watermark_opacity": "Watermark Opacity",
  "concepts_per_week": "Concepts Per Week",
  "mastery_progression": "Mastery Progression",
  "question_depth": "Question Depth",
  "risk_level": "Risk Level",
  "risk_low": "Low Risk",
  "risk_medium": "Medium Risk",
  "risk_high": "High Risk",
  "risk_critical": "Critical Risk",
  "factor_breakdown": "Factor Breakdown",
  "needs_attention": "Needs Attention",
  "view_journey": "View Journey",
  "no_engagement_data": "No engagement data available",
  "extract_content": "Extract Content",
  "extraction_status": "Extraction Status",
  "content_extracted": "Content Extracted",
  "extract_processing": "Processing...",
  "extract_completed": "Extraction Completed",
  "extract_failed": "Extraction Failed",
  "extracted_text": "Extracted Text",
  "trigger_extraction": "Trigger OCR Extraction",
  "mathpix_not_configured": "Mathpix OCR not configured",
  "s3_upload": "S3 Upload",
  "generate_upload_url": "Generate Upload URL",
  "s3_not_configured": "AWS S3 not configured",
  "presigned_url_generated": "Upload URL generated",
  "approve_leave": "Approve Leave",
  "audit_trail": "Audit Trail",
  "backup": "Backup",
  "bulk_delete": "Bulk Delete",
  "create_exam": "Create Exam",
  "custom_fields": "Custom Fields",
  "dashboard": "Dashboard",
  "design_admit_card": "Design Admit Card",
  "design_marksheet": "Design Marksheet",
  "disable_reason": "Disable Reason",
  "driver_trips": "Driver Trips",
  "email_sms_log": "Email / SMS Log",
  "exam_group": "Exam Group",
  "fee_carry_forward": "Fee Carry Forward",
  "fee_reminder": "Fee Reminder",
  "general_setting": "General Settings",
  "hostel_complaints": "Hostel Complaints",
  "hostel_qr_scanner": "Hostel QR Scanner",
  "maintenance": "Maintenance",
  "multi_class_student": "Multi Class Student",
  "my_performance": "My Performance",
  "my_transport": "My Transport",
  "online_admission": "Online Admission",
  "online_exam": "Online Exam",
  "parts_stock": "Parts & Stock",
  "practice": "Practice",
  "practice_analytics": "Practice Analytics",
  "practice_questions": "Practice Questions",
  "print_admit_card": "Print Admit Card",
  "print_marksheet": "Print Marksheet",
  "qr_attendance": "QR Attendance",
  "question_bank": "Question Bank",
  "route_stops": "Route Stops",
  "send_email": "Send Email",
  "send_sms": "Send SMS",
  "settings": "Settings",
  "student_house": "Student House",
  "student_profile_update": "Student Profile Update",
  "syllabus_status": "Syllabus Status",
  "system_fields": "System Fields",
  "teachers_rating": "Teachers Rating",
  "teachers_review": "Teachers Review",
  "transport_analytics": "Transport Analytics",
  "transport_notifications": "Transport Notifications",
  "trips": "Trips",
  "vendors": "Vendors",
  "allocations": "Allocations",
  "hostel_attendance": "Hostel Attendance",
  "visitor_log": "Visitor Log",
  "chat_settings": "Chat Settings",
  "start_new_chat": "Start New Chat",
  "create_group": "Create Group",
  "group_name": "Group Name",
  "group_members": "Group Members",
  "add_members": "Add Members",
  "remove_member": "Remove Member",
  "leave_group": "Leave Group",
  "mute_chat": "Mute Chat",
  "unmute_chat": "Unmute Chat",
  "block_user": "Block User",
  "unblock_user": "Unblock User",
  "typing": "typing...",
  "offline": "Offline",
  "last_seen": "Last Seen",
  "delivered": "Delivered",
  "reply": "Reply",
  "forward": "Forward",
  "search_messages": "Search Messages",
  "no_messages_yet": "No messages yet",
  "replies_disabled": "Replies are disabled by admin",
  "file_too_large": "File size exceeds limit",
  "organization_directory": "Organization Directory",
  "filter_by_department": "Filter by Department",
  "filter_by_designation": "Filter by Designation",
  "filter_by_role": "Filter by Role",
  "filter_by_class": "Filter by Class",
  "all_departments": "All Departments",
  "all_designations": "All Designations",
  "only_admins_can_send": "Only Admins Can Send",
  "communication_rules": "Communication Rules",
  "group_settings": "Group Settings",
  "file_settings": "File & Media Settings",
  "moderation_settings": "Moderation",
  "display_settings": "Display Settings",
  "auto_create_groups": "Auto-Create Groups",
  "online_examinations": "Tests",
  "take_exams_view_results": "Take exams, view results, and track your performance",
  "live": "Live",
  "upcoming": "Upcoming",
  "missed": "Missed",
  "all_types": "All Types",
  "newest_first": "Newest First",
  "oldest_first": "Oldest First",
  "search_exams": "Search exams...",
  "start_exam": "Start Exam",
  "view_result": "View Result",
  "not_started_yet": "Not started yet",
  "no_exams_found": "No exams found",
  "try_adjusting_filters": "Try adjusting your filters or check back later.",
  "enter_exam_otp": "Enter Exam OTP",
  "otp_instruction": "This exam requires an OTP to start. Please enter the OTP provided by your instructor.",
  "verify_and_start": "Verify & Start",
  "enter_otp": "Enter OTP...",
  "otp_protected": "OTP Protected",
  "rank_awaited": "Rank Awaited",
  "loading_exams": "Loading exams...",
  "loading_exam": "Loading exam...",
  "loading_result": "Loading result...",
  "mark_for_review": "Mark for Review",
  "clear_answer": "Clear Answer",
  "save_and_next": "Save & Next",
  "submit_exam": "Submit Exam",
  "submit_now": "Submit Now",
  "time_over": "Time's Up!",
  "auto_submitting": "Auto-submitting in",
  "seconds": "seconds",
  "exam_submitted_successfully": "Exam Submitted Successfully!",
  "answers_recorded": "Your answers have been recorded.",
  "back_to_exams": "Back to Exams",
  "waiting_for_internet": "Waiting for Internet",
  "syncing_answers": "Your answers are saved locally. They will sync automatically when connection is restored.",
  "retry_now": "Retry Now",
  "storage_full": "Storage Full",
  "storage_full_instruction": "Your browser storage is full. Follow these steps to free space.",
  "submit_confirmation": "Submit Exam?",
  "are_you_sure_submit": "Are you sure you want to submit this exam?",
  "check_back_later": "Please check back later.",
  "marks_obtained": "Marks Obtained",
  "skipped": "Skipped",
  "not_attempted": "Not Attempted",
  "exam_analytics": "Exam Analytics",
  "exam_behaviour": "Exam Behaviour",
  "all_subjects": "All Subjects",
  "all_lessons": "All Lessons",
  "all_topics": "All Topics",
  "question_no_asc": "Question No ↑",
  "question_no_desc": "Question No ↓",
  "time_taken_asc": "Time Taken ↑",
  "time_taken_desc": "Time Taken ↓",
  "search_question_text": "Search question text...",
  "filters": "Filters",
  "hide": "Hide",
  "load_solution": "Load Solution",
  "solution_loaded": "Solution Loaded",
  "no_solution_available": "No solution available.",
  "graphs": "Graphs",
  "score_distribution": "Score Distribution",
  "top_performers": "Top Performers",
  "subject_performance_vs_avg": "Subject Performance vs Class Average",
  "subject_marks": "Subject Marks",
  "subject_time": "Subject Time",
  "answer_distribution": "Answer Distribution",
  "subject_accuracy_speed": "Subject-wise Accuracy & Speed",
  "accuracy": "Accuracy",
  "exam_expired": "This exam has expired.",
  "failed_to_load_exam": "Failed to load exam",
  "network_error": "Network error",
  "invalid_otp": "Invalid OTP",
  "correct_ans": "Correct",
  "grace_marks_applied": "Grace marks applied",
  "already_finalized": "Already finalized",
  "total_attempts": "Total Attempts",
  "csv": "CSV",
  "json": "JSON",
  "exam_behaviour_coming_soon": "Exam behaviour review coming soon.",
  "exam_behaviour_dashboard": "Exam Behaviour Dashboard",
  "interactive_timeline": "Interactive Timeline",
  "session_flow": "Session Flow",
  "question_heatmap": "Question Heatmap",
  "per_question_details": "Per-question Details",
  "session_insights": "Session Insights & Charts",
  "suspicion_score": "Suspicion Score",
  "device_environment": "Device & Environment",
  "suspicious_activity": "Suspicious Activity Tracker",
  "tips_notes": "Tips & Notes",
  "personalized_summary": "Personalized Behaviour Summary",
  "total_actions": "Total Actions",
  "avg_time_per_question": "Avg Time / Question",
  "median_time": "Median Time",
  "question_switches": "Question Switches",
  "answer_changes": "Answer Changes",
  "idle_gaps_label": "Idle Gaps (>60s)",
  "quick_answer_alert": "Quick Answer",
  "answer_changed_alert": "Answer Changed",
  "frequent_switch_alert": "Frequent Switch",
  "rapid_action_alert": "Rapid Action",
  "guess_streak_alert": "Guess Streak",
  "overthinking_alert": "Overthinking",
  "late_backtrack_alert": "Late Backtrack",
  "skipped_alert": "Skipped",
  "viewed_label": "Viewed",
  "switch_next_label": "Switch / Next",
  "answer_label": "Answer",
  "compact_spacing": "Compact Spacing",
  "focus_spans": "Focus Spans",
  "target_pace": "Target Pace",
  "moving_avg": "Moving Average",
  "band_p10_p90": "Band p10–p90",
  "coverage_label": "Coverage",
  "volatility_label": "Volatility",
  "longest_idle": "Longest Idle",
  "active_pct": "Active %",
  "download_csv": "Download CSV",
  "download_overall": "Download Overall",
  "download_summary": "Download Summary",
  "back_to_result": "Back to Result",
  "no_behaviour_data": "No behaviour data available for this exam",
  "pace_trend": "Pace Trend",
  "charts": "Charts",
  "jump_to_insights": "Jump to Insights",
  "bulk_progress_report": "Bulk Progress Report Cards",
  "acknowledge": "I have read and acknowledge this notice",
  "action_cannot_undone": "This action cannot be undone.",
  "actions": "Actions",
  "add_lesson": "Add Lesson",
  "add_room": "Add Room",
  "add_topic": "Add Topics",
  "admission_form": "Online Admission Form",
  "advanced_reports": "Advanced Reports",
  "all_buildings": "All Buildings",
  "all_categories": "All Categories",
  "all_classes": "All",
  "all_classes_done": "All classes done for today!",
  "all_fields_required": "All fields are required",
  "all_hostel_rooms": "All Hostel Rooms",
  "all_hostels": "All Hostels",
  "all_parents": "All Parents",
  "all_sections": "All sections",
  "all_students": "All Students",
  "allocate_student": "Allocate Student",
  "alt_phone": "Alt Phone",
  "answered": "Answered",
  "application": "Applications",
  "apply_date": "Apply Date",
  "asset_code": "Asset Code",
  "asset_deployment": "Asset Deployment (By Location)",
  "assigned_classes": "Assigned classes",
  "assignment": "Assignment",
  "attendance_analytics": "Attendance Analytics",
  "authorized_signatory": "Authorized Signatory",
  "auto": "Auto",
  "auto_attendance": "Auto Attendance",
  "available_qty": "Available Qty",
  "average": "Avg",
  "avg_marks": "Avg Marks",
  "avg_percentage": "Avg %",
  "avg_price": "Avg Price",
  "avg_rating": "Avg Rating",
  "back_camera": "Back Camera",
  "back_to_list": "Back to list",
  "backup_desc": "Create and manage database backups. Backups include all tables, routines, and triggers.",
  "backup_info": "Backup Information",
  "balance_below_threshold": "Your SMS balance is below 100. Please recharge to avoid service disruption.",
  "balance_refreshed": "Balance refreshed",
  "bank_details": "Bank Details",
  "bed_no": "Bed No",
  "beds_empty": "Beds Empty",
  "beds_filled": "Beds Filled",
  "below": "Below",
  "biometric_logs": "Biometric Logs",
  "birthday": "Birthday",
  "book_issued_successfully": "Book issued successfully",
  "book_returned_successfully": "Book returned successfully",
  "building_name": "Building Name",
  "call_driver": "Call Driver",
  "calls": "Calls",
  "camera": "Camera",
  "capacity": "Capacity",
  "caste": "Caste",
  "channel": "Channel",
  "check_in": "Check-In",
  "check_out": "Check-Out",
  "checked_in_today": "Checked In Today",
  "chronic_absentees": "Chronic Absentees",
  "class_wise": "Class-wise",
  "class_wise_attendance": "Class-wise Attendance",
  "class_wise_summary": "Class-wise Fee Collection",
  "clear_all": "Clear all",
  "click_start": "Click \"Start Camera\" to begin scanning",
  "collected": "Collected",
  "collection_rate": "Collection Rate",
  "coming_soon": "Coming Soon",
  "complaint_no": "#No",
  "complaints": "Complaints",
  "complaints_desc": "Track, assign, and resolve hostel maintenance issues",
  "completed": "Completed",
  "configuration": "Configuration",
  "confirm_and_submit": "Confirm & Submit",
  "confirm_attendance_submission": "Confirm Attendance Submission",
  "content_footer": "Footer Instructions",
  "cooldown": "Cooldown (sec)",
  "counselling": "Counselling",
  "currency_place": "Currency Symbol Place",
  "database_backup": "Database Backup",
  "day_view": "Day View",
  "day_wise": "Day Wise",
  "default_return_days_placeholder": "e.g. 7",
  "delete_category_confirm": "Delete category",
  "delete_item_confirm": "Delete item",
  "delete_stock_confirm": "Delete this stock entry?",
  "delete_store_confirm": "Delete store",
  "delete_supplier_confirm": "Delete supplier",
  "delivered_at": "Delivered At",
  "delivery_log": "Delivery Log",
  "delivery_rate": "Delivery Rate",
  "deselect": "Deselect",
  "detail": "Details",
  "dispatch": "Dispatch",
  "dlt_balance": "DLT Balance",
  "dlt_registered": "DLT Registered Templates",
  "document": "Document",
  "download_excel_template": "Download Excel Template",
  "drag_drop": "Drag & drop file or click to browse",
  "driver_licence": "Driver Licence",
  "due_today": "Due Today",
  "emails_sent": "Emails Sent",
  "employee_id": "Employee ID",
  "enable_disable_modules": "Enable or disable system modules for staff, students, and parents",
  "enter_address": "Enter address",
  "enter_amount": "Enter amount",
  "enter_code": "Enter code",
  "enter_contact_person_email": "Enter contact person email",
  "enter_contact_person_name": "Enter contact person name",
  "enter_contact_person_phone": "Enter contact person phone",
  "enter_description": "Enter description",
  "enter_email": "Enter email",
  "enter_invoice_no": "Enter invoice no",
  "enter_item_name": "Enter item name",
  "enter_location_name": "Enter store name",
  "enter_name": "Enter name",
  "enter_note": "Enter note",
  "enter_phone": "Enter phone",
  "enter_reason": "Enter reason for leave...",
  "enter_store_code": "Enter store code",
  "enter_supplier_name": "Enter supplier name",
  "error_code_reference": "Error Code Reference",
  "error_deleting": "Error deleting",
  "error_saving": "Error saving",
  "errors": "Errors",
  "event_type": "Event Type",
  "event_types": "Event Types",
  "exam_center": "Exam Center",
  "exam_groups": "Exam Groups",
  "exam_type": "Exam Type",
  "exam_type_placeholder": "e.g. Final, Mid-term",
  "excellent": "Excellent",
  "expected": "Expected",
  "expected_return": "Expected Return",
  "expires": "Expires",
  "export_csv": "Export CSV",
  "export_success": "CSV exported successfully!",
  "failed": "Failed",
  "fees_assign": "Assign Fee Group",
  "fees_due_days": "Fee Due Days",
  "file": "File",
  "filename": "Filename",
  "files": "files",
  "filter": "Filter",
  "fine_amount": "Fine / Penalty Amount (Optional)",
  "fleet_management": "Fleet Management",
  "floor": "Floor",
  "footer_content": "Footer Content",
  "front_camera": "Front Camera",
  "full": "Full",
  "gate_pass": "Gate Pass",
  "general": "General",
  "generate_print": "Generate & Print",
  "download_zip": "Download ZIP",
  "good": "Good",
  "grace_minutes": "Grace Minutes",
  "grade_point": "Grade Point",
  "guardian_is": "Guardian Is",
  "history": "History",
  "hostel_dashboard": "Hostel Dashboard",
  "hostel_dashboard_desc": "Overview of hostel occupancy, attendance & maintenance",
  "hostel_occupancy": "Hostel Occupancy",
  "hostel_room": "Hostel Room",
  "hostels": "Hostels",
  "id_proof": "ID Proof",
  "inactive": "Inactive",
  "issue_history": "Issue History",
  "issue_type": "Issue To Type",
  "item_code_prefix": "Item Code Prefix",
  "item_code_prefix_placeholder": "e.g. INV-",
  "item_issued_success": "Item issued successfully",
  "item_locations": "Manage Locations",
  "item_name_category_required": "Item name and category are required",
  "item_returned_success": "Item returned successfully",
  "item_stock": "Item Stock",
  "last_updated": "Last updated",
  "layout": "Layout",
  "leave_details": "Leave Details",
  "leave_requests": "Leave Requests",
  "left_logo": "Left Logo",
  "live_bus_tracking": "Live Bus Tracking",
  "load_periods": "Load Periods",
  "location": "Location",
  "location_name": "Location Name",
  "location_name_required": "Store name required",
  "location_names": "Item Locations",
  "low_sms_balance": "Low SMS Balance Warning",
  "manage_captcha": "Enable or disable captcha for different pages",
  "manage_custom_fields": "Manage custom field definitions for students and staff",
  "manage_exams": "Manage Exams",
  "manage_file_types": "Select allowed file extensions. MIME types are automatically mapped.",
  "manage_hostels": "Manage hostel buildings and their infrastructure",
  "manage_languages": "Manage languages",
  "manage_profile_update": "Control which fields students can edit in their own profile",
  "manage_room_types": "Define categories like Single, Double, Dormitory, etc.",
  "manage_rooms_desc": "View rooms, beds, and occupancy. Click a card to see the bed map.",
  "manage_system_fields": "Toggle visibility of form fields for students and staff",
  "manage_user_accounts": "Manage staff, student, and parent login accounts",
  "manual_entry": "Manual Entry",
  "mark": "Mark",
  "mark_all": "All",
  "mark_attendance": "Mark Attendance",
  "mark_entry": "Mark Entry",
  "marked": "Marked",
  "marks_saved": "Marks saved",
  "max_marks": "Max",
  "min_marks": "Min",
  "module_wise_breakdown": "Module-Wise Breakdown",
  "monthly_breakdown": "Monthly Breakdown",
  "monthly_report": "Monthly Report",
  "mother_tongue": "Mother Tongue",
  "my_inventory": "My Inventory",
  "my_inventory_desc": "View all inventory items assigned to you.",
  "my_room": "My Room",
  "my_stop": "My Stop",
  "nationality": "Nationality",
  "needs_improvement": "Needs Improvement",
  "new_complaint": "New Complaint",
  "no_backups": "No backups found. Create your first backup above.",
  "no_birthdays_today": "No birthdays today",
  "no_chronic_absentees": "No chronic absentees",
  "no_class": "No class",
  "no_classes_scheduled": "No classes scheduled",
  "no_classes_today": "No classes scheduled today!",
  "no_content": "No content added for this topic yet",
  "no_data_found": "No data found",
  "no_error_codes": "No error codes available",
  "no_exam_groups": "No exam groups yet. Click \"Add Group\" to create one.",
  "no_fees_assigned": "No fee records have been assigned yet.",
  "no_file": "No file",
  "no_grades": "No grades defined",
  "no_holiday_type": "No Holiday attendance type found",
  "no_hostel_assigned": "You are not currently assigned to any hostel room.",
  "no_items_found": "No items assigned to you yet.",
  "no_leave_requests": "No leave requests",
  "no_lessons_found": "No lessons found for this subject",
  "no_logs": "No SMS logs found for the selected filters",
  "no_matching_codes": "No matching error codes",
  "no_notifications_yet": "No notifications yet",
  "no_of_people": "People",
  "no_overdue": "No overdue books",
  "no_permission": "You do not have permission to do this.",
  "no_recent_activity": "No recent activity",
  "no_remark": "—",
  "no_scans_yet": "No scans yet",
  "no_students_marked_absent": "No students marked as Absent.",
  "no_subjects_scheduled": "No subjects scheduled for this exam",
  "no_teachers": "No teachers assigned to your class",
  "no_template": "No template",
  "no_topics": "No topics",
  "no_transport_assigned": "You are not currently assigned to any transport route.",
  "no_trips": "No trips configured",
  "no_vehicle_allotted": "No vehicle allotted",
  "not_found": "Not found",
  "not_visited": "Not visited",
  "notification": "Notifications",
  "notification_center": "Notification Center",
  "notifications_will_appear": "You'll see alerts here when exam results, attendance, fees, etc. are published",
  "now": "Now",
  "occupancy": "Occupancy %",
  "occupied": "Occupied",
  "online_payment": "Online Payment",
  "open": "Open",
  "open_complaints": "Open Complaints",
  "organisation": "Organisation",
  "overall_progress": "Overall Progress",
  "overdue_items": "Overdue Items List",
  "parents": "Parents",
  "pass_no": "Pass No",
  "payment_mode": "Payment mode",
  "payment_success": "Payment successful",
  "pdf_inline_unsupported": "This PDF could not be displayed. Download the file to read it.",
  "pending_ack": "Pending Ack",
  "performance": "Performance",
  "period_wise": "Period Wise",
  "period_wise_report": "Period-wise Report",
  "periods": "Periods",
  "permitted_by": "Permitted By",
  "personal_details": "Personal Details",
  "photos": "Photos",
  "pincode": "Pincode",
  "pinned": "Pinned",
  "place_of_birth": "Place of Birth",
  "play_video": "Play Video",
  "present_days": "Present",
  "previous_school": "Previous School",
  "quick_actions": "Quick Actions",
  "rate_your_teachers": "Rate and review your class teachers",
  "rated": "You Rated",
  "receive": "Receive",
  "recent": "Recent Uploads",
  "recent_complaints": "Recent Complaints",
  "recent_issues": "Recent Issues",
  "recent_scans": "Recent Scans",
  "recent_stock_additions": "Recent Stock Additions",
  "record_saved_successfully": "Saved successfully",
  "record_updated_successfully": "Updated successfully",
  "refresh": "Refresh",
  "refresh_balance": "Refresh Balance",
  "reject": "Reject",
  "relation": "Relation",
  "remark": "Remark",
  "resolved": "Resolved",
  "results": "Results",
  "retry": "Retry",
  "return_condition": "Return Condition",
  "return_item_confirm": "Return item",
  "roommates": "Roommates",
  "rooms": "Rooms",
  "save_marks": "Save Marks",
  "saved_templates": "Saved Templates",
  "scale": "Scale",
  "scanner": "Scanner",
  "schedule": "Schedule",
  "search_by_expense": "Search by Expense",
  "search_by_income": "Search by Income",
  "search_by_item": "Search by item name...",
  "search_error_codes": "Search error codes...",
  "search_issues": "Search by item, person or asset code...",
  "search_phone": "Search phone...",
  "select_currency": "Select Currency",
  "select_filters": "Select filters and click Search to load students",
  "select_period": "Select a period from above to mark attendance",
  "select_session": "Select Session",
  "select_students": "Select Students",
  "sendmail_description": "Sendmail uses the server's built-in mail function. No additional configuration is required.",
  "sent": "Sent",
  "sent_at": "Sent At",
  "server_running_hint": "Make sure the server is running and the database tables exist.",
  "setup": "Setup",
  "severity": "Severity",
  "showing": "Showing",
  "size": "Size",
  "sms_balance": "SMS Balance",
  "sms_reports": "SMS Reports",
  "sms_sent": "SMS Sent",
  "staff_incharge": "Floor-wise Staff Incharge",
  "staff_incharge_desc": "Assign staff to manage specific hostel floors",
  "staff_modules": "Staff Modules",
  "start_camera": "Start Camera",
  "start_month": "Start month",
  "stock_added": "Stock added successfully",
  "stock_history": "Stock History",
  "stock_valuation": "Stock Valuation by Item",
  "stop": "Stop",
  "stops": "Stops",
  "stops_completed": "stops completed",
  "student_hostel_report": "Student Hostel Report",
  "student_hostel_report_desc": "Cross-reference of students with their hostel allocation details",
  "student_id_or_admission_no": "Student ID or Admission No",
  "student_stops": "Student-Stop Assignments",
  "subject_wise": "Subject-wise Mode",
  "subject_wise_attendance": "Subject-wise Attendance",
  "submit_date": "Submit By",
  "switch_session": "Switch Academic Session",
  "syllabus_entry": "syllabus entry",
  "sync_dlr": "Sync DLR",
  "this_cannot_be_undone": "This cannot be undone.",
  "time_spent": "Time Spent",
  "to_date_must_be_after_from": "To date must be ≥ From date",
  "today_absentees": "Today's Absentees",
  "today_attendance": "Today's Attendance",
  "today_attendance_rate": "Today's Attendance Rate",
  "today_birthday": "Today's Birthdays",
  "today_distribution": "Today's Distribution",
  "toggle_fields": "Toggle Fields",
  "topics_completed": "topics completed",
  "total_absentees": "Total Absentees",
  "total_beds": "Total Beds",
  "total_days": "Total",
  "total_exams": "Total Exams",
  "total_hostels": "Total Hostels",
  "total_records": "Records",
  "total_rooms": "Total Rooms",
  "total_sent": "Total Sent",
  "total_students": "Total Students",
  "total_teachers": "Teachers",
  "total_value": "Total Value",
  "transport_dashboard": "Transport Dashboard",
  "transport_route": "Transport Route",
  "try_again": "Try again",
  "unit_placeholder": "e.g. pcs, kg",
  "unmarked": "Unmarked",
  "unmarked_classes": "Unmarked Classes Today",
  "unread": "Unread",
  "unsaved_changes": "Unsaved changes",
  "unsaved_changes_warning": "You have unsaved changes. Leave anyway?",
  "variables": "Available Variables",
  "vehicle_details": "Vehicle Details",
  "video": "video",
  "view_all_notifications": "Stay updated with school announcements & alerts",
  "view_attachment": "View Attachment",
  "view_exam_schedule": "View and download your examination schedule",
  "view_hostel_rooms_info": "View your hostel room allocation and all available rooms",
  "view_transport_details": "View your transport route, stops, and live bus tracking",
  "visitor_desc": "Track visitors, parents, and guests visiting students",
  "visitors": "Visitors",
  "week_view": "Week View",
  "weekly_schedule": "Weekly Schedule",
  "weekly_trend": "Weekly Trend (7 Days)",
  "wing": "Wing",
  "left_sign": "Left Signature",
  "middle_sign": "Middle Signature",
  "right_sign": "Right Signature",
  "right_logo": "Right Logo",
  "save_template": "Save Template",
  "counted": "Counted",
  "half_a_day": "Half a day",
  "a_full_day": "A full day",
  "attendance_percentage_policy": "Attendance percentage policy",
  "attendance_policy_intro": "This decides how every attendance percentage is worked out: the class report, the student profile, the progress card and the parent app all read it.",
  "late_counts_as": "A Late mark counts as",
  "half_day_counts_as": "A Half Day mark counts as",
  "attendance_policy_note": "Changing this changes the percentages shown from now on. The marks themselves are untouched, so setting it back restores the old figures exactly.",
  "save_policy": "Save policy",
  "could_not_save_policy": "Could not save the policy",
  "consecutive_absences": "Consecutive absences",
  "absence_alert_threshold": "Students absent for at least",
  "school_days_running": "school days running",
  "send_alerts_each_evening": "Send alerts each evening",
  "absence_alert_help": "One message per run of absences, not one a night.",
  "days_in_a_row": "Days in a row",
  "notify_guardian": "Notify the guardian",
  "no_absence_runs": "Nobody is currently absent that many days running.",
  "no_number_on_file": "No number on file",
  "alerts_sent": "Alerts sent",
  "nothing_yet": "Nothing yet"
}
